export const enMessages = {
  hostRewardsSummary: {
    SectionHeader: 'Host Rewards Summary',
    NoRewardsEarned: 'The host has not earned any rewards yet.',
    Earned: 'Earned',
    EarnedLabel: 'Earned:',
    RemainingLabel: 'Remaining:',
    FreeDollars: 'Host dollars',
    PercentageOffItem: 'Percentage-off products',
    PercentageOffOrder: 'Percentage off order',
    DiscountedSkuFromList: 'Discounted products',
    DiscountedItem: 'Discounted product',
    SelectFreeProduct: 'Free products',
    FreeProduct: 'Free product',
    FreeShipping: 'Free shipping',
    Coupon: 'Coupon',
    Other: 'Reward',
  },
  rma: {

    ProductReturnsTitle: 'Product Returns',

    AllProductReturns: 'All product returns',

    KeepTrackDescription: 'Keep track of all your product returns',

    NewProductReturn: 'New Product Return',

    SearchByNameOrReference: 'Search by name or reference number...',

    Filters: 'Filters',

    ReturnsWithNoTracking: 'Returns with no tracking number',

    From: 'From',

    ComplaintsTitle: 'Complaints',

    ReviewAndManage: 'Review and manage customer complaints',

    RecordComplaint: 'Record Complaint',

    Status: 'Status',

    SelectStatus: 'Select status',

    MaxResults: 'Max. Results',

    SelectColumn: 'Column',

    SelectOperator: 'Operator',

    SearchFor: 'Search For',

    SearchPlaceholder: 'Enter search text...',

    Search: 'Search',

    Filter: 'Filter',

    FilterTitle: 'Filter Complaints',

    ApplyFilters: 'Apply Filters',

    ClearFilters: 'Clear Filters',

    CloseFilters: 'Close',

    NoComplaintsFound: 'No complaints found for the selected criteria.',

    LastName: 'Last Name',

    FirstName: 'First Name',

    Name: 'Name',

    RMANumber: 'RMA Number',

    RMADetails: 'RMA Details',

    DateOfSubmission: 'Date of Submission',

    CreatedDate: 'Created Date',

    FeeTotal: 'Fee Total',

    Total: 'Total',

    TrackingNumber: 'Tracking Number',

    NoTrackingProvided: 'No tracking provided',

    Showing: 'Showing',

    To: 'to',

    Of: 'of',

    Entries: 'entries',

    Previous: 'Previous',

    Next: 'Next',

    FirstPage: 'First page',

    PreviousPage: 'Previous page',

    NextPage: 'Next page',

    LastPage: 'Last page',

    Close: 'Close',

    ReturnStatus: 'Return Status',

    CustomerInformation: 'Customer Information',

    ComplaintDetails: 'Complaint Details',

    ProductInformation: 'Product Information',

    RefundInformation: 'Refund Information',

    RefundAmount: 'Refund Amount',

    ShippingAmount: 'Shipping Amount',

    ShippingMethod: 'Shipping Method',

    AOEOrderId: 'AOE Order ID',

    ClosedDate: 'Closed Date',

    IsSubmitted: 'Is Submitted',

    ExportDate: 'Export Date',

    Notes: 'Notes',

    Yes: 'Yes',

    NotAvailable: 'Not Available',

    All: 'All',

    Open: 'Open',

    WillBeShipped: 'Will Be Shipped',

    Closed: 'Closed',

    Cancelled: 'Cancelled',

    OnHold: 'On Hold',

    ReturnExpected: 'Return Expected',

    CreditDebitProcessingError: 'Credit/Debit Processing Error',

    ClosedWithoutReturns: 'Closed Without Returns',

    New: 'New',

    ManualReimbursementRequired: 'Manual Reimbursement Required',

    PhotoIsMissing: 'Photo Is Missing',

    ReceiptInProcess: 'Receipt In Process',

    ReleaseAwaited: 'Release Awaited',

    StartsWith: 'Starts With',

    EndsWith: 'Ends With',

    Contains: 'Contains',

    Equals: 'Equals',

    Between: 'Between',

    GreaterThan: 'Greater Than',

    LessThan: 'Less Than',

    ItemsBeingReturned: 'Items Being Returned',

    ReplacementItems: 'Replacement Items',

    Exit: 'Exit',

    SubmitSuccess: 'Success!',

    RMASubmittedSuccessfully: 'RMA {rmaNumber} submitted successfully!',

    ReturnAddress: 'Return Address',

    NoAddressSelected: 'No address selected',

    SelectAddress: 'Select Address',

    SelectReturnAddress: 'Select Return Address',

    AddNewAddress: 'Add New Address',

    SubmitRMA: 'Submit RMA',

    GoBack: 'Go Back',

    AddressSaved: 'Address Saved',

    AddressSaveError: 'Failed to save address',

    RequiredAddressFields: 'Please fill in all required address fields',

    SelectReasonPlaceholder: 'Select a reason...',

    returnReasons: {

      DUR: 'Breakage during use - DUR',

      DSR: 'Breakage on delivery - DSR',

      EXR: 'Exchange Return - EXR',

    },

    errors: {

      enterOrderNumber: 'Please enter an order number',

      enterValidOrderNumber: 'Please enter a valid order number',

      failedToLoadOrderDetails: 'Failed to load order details. Please try again.',

      orderNotFound: 'Order not found. Please check the order number and try again.',

      failedToSearchOrder: 'Failed to search for order. Please try again.',

      orderDetailsNotFound: 'Order details not found',

      rmaNotCreated: 'RMA not created. Please go back and try again.',

      failedToSubmitRMA: 'Failed to submit RMA. Please try again.',

      failedToUpdateRefund: 'Failed to update refund selection. Please try again.',

      failedToLoadPaymentMethods: 'Failed to load available payment methods. Please try again.',

      selectAtLeastOneItemToReturn: 'Please select at least one item or component to return',

      selectReasonForAllSelectedItems: 'Please select a reason for all selected items',

      selectReasonForAllSelectedComponents: 'Please select a reason for all selected components',

      failedToCreateRMA: 'Failed to create RMA. Please try again.',

    },

    ExchangeItemRequired: 'Exchange Item Required',

    ExchangeItemRequiredMessage: 'Please select an exchange item for all items marked for exchange',

    UploadPhotos: 'Upload Photos & Videos',

    UploadPhotosTitle: 'Upload Return Item Photos & Videos',

    UploadNewPhotos: 'Upload New Photos & Videos',

    PreviouslyUploadedPhotos: 'Previously Uploaded Photos & Videos',

    PhotoRequired: 'Required',

    PhotoRequiredMessage: 'Please upload photos or videos for all items that require them. Look for items marked with a red asterisk (*).',

    // Order details grid

    Details: 'Details',

    Warehouse: 'Warehouse',

    LastUpdated: 'Last updated',

    OrderTotal: 'Order Total',

    OrderType: 'Order Type',

    Orders: 'Order',

    OrderNumber: 'Order number',

    OrderDate: 'Order date',

    ComplaintSubmitted: 'Complaint submitted',

    Guests: 'Guest',

    Customer: 'Customer',

    CustomerStatus: 'Customer status',

    DeliveryAddress: 'Delivery address',

    EmailAddress: 'Email address',

    PhoneNumber: 'Phone number',

    Consultant: 'Consultant',

    Advisor: 'Advisor',

    GoodStanding: 'Good Standing',

    FinancialState: 'Financial State',

    // Reason codes

    ReasonCodesTitle: 'Return Reason Codes',

    ReasonCodeDUR: 'DUR - Breakage in Use',

    ReasonCodeDURDescription: 'The product is defective during use.',

    ReasonCodeDSR: 'DSR - Breakage on Delivery',

    ReasonCodeDSRDescription: 'The product arrived damaged.',

    ReasonCodePQ: 'PQR - Product Quality',

    ReasonCodePQDescription: 'The product was delivered with a defect or fault.',

    ReasonCodeEX: 'EXR - Exchange',

    ReasonCodeEXDescription: 'Exchange for a different item.',

    ReasonCodesNote: 'Note: Exchanges of items older than 30 days are not accepted. Once you have successfully submitted your claim, a return label will be created by the Customer Service Team within 48-72 hours. You will receive a separate email containing your return label.',

    // Exchange item selection

    SelectExchangeItem: 'Select Exchange Item',

    SearchForProduct: 'Search for product (min 3 characters)...',

    ExchangeItemSelected: 'Exchange Item Selected',

    RemoveExchangeItem: 'Remove & Select Different Item',

    // Component section

    SKUComponents: 'SKU Components',

    Reason: 'Reason',

    InitiateReturn: 'Initiate a Return',

    EnterOrderNumber: 'Enter your order number below to begin the return process.',

    OrderNumberPlaceholder: 'Enter order number...',

    Searching: 'Searching...',

    ExistingRMAFound: 'Existing RMA Found',

    ExistingRMAMessage: 'An existing RMA has already been submitted for this order.',

    ExistingRMAInfo: 'Please contact customer service if you need assistance with this return.',

    SelectItemsToReturn: 'Select Items to Return',

    SelectItemsInstruction: 'Select the items you wish to return and provide a reason for each.',

    SKU: 'SKU',

    ProductCode: 'Product Code',

    Quantity: 'Quantity',

    LineTotal: 'Line Total',

    ReturnReason: 'Return Reason',

    ItemsSelected: 'item(s) selected',

    ProceedWithReturn: 'Proceed with Return',

    ItemsToReceive: 'Items to Receive',

    Totals: 'Totals',

    CreditAmount: 'Credit Amount',

    Fees: 'Fees',

    ReturnCreditBalance: 'Return Credit Balance',

    NewPurchases: 'New Purchases',

    BuyingDiscount: 'Buying Discount',

    RefundMethod: 'Refund Method',

    ReturnCreditRequired: 'A credit is owed to you for this return. Select how you would like it refunded.',

    RefundOriginalPaymentMethod: 'Refund to original payment method',

    RefundColumnName: 'Payment',

    RefundColumnCharge: 'Original Charge',

    RefundColumnChargeNotRefunded: 'Available to Refund',

    RefundColumnRefundAmount: 'Refund Amount',

    RefundRemainingToAllocate: '{amount} still needs to be allocated to a refund method before you can submit this return.',

    PaymentRequired: 'Payment Required',

    PaymentRequiredDescription: 'An additional payment is required to complete this return. Please provide a payment method below.',

    BrainTreeCreditCardHeader: 'Credit Card',

    BrainTreePaymentAmount: 'Payment Amount',

    BrainTreeAddPayment: 'Add Payment',

    BankPaymentHeader: 'Pay with Bank Account',

    BankPaymentInstruction: 'Make a payment using your bank account to cover the balance owed on this return.',

    BankPaymentYourBankDetails: 'Your Bank Details',

    BankPaymentAccountHolder: 'Account Holder',

    BankPaymentAccountNumber: 'Account Number',

    BankPaymentRoutingNumber: 'Routing Number',

    BankPaymentAmount: 'Payment Amount',

    BankPaymentPayWithBank: 'Pay with Bank Account',

    BankPaymentProcessing: 'Processing...',

    BankPaymentNoBankDetailsFound: 'No bank details found. Please add your bank details to use this payment method.',

  },

  applicationMessages: {

    English: 'English',

    Spanish: 'Spanish (Español)',

    French: 'French (Français)',

    German: 'German (Deutsch)'

  },



  validators: {

    requiredField: '{fieldName} is required',

    emailField: '{fieldName} is an invalid email address',

    nameField: '{fieldName} can only contain letters, spaces, hyphens, and apostrophes',

    fieldLength:

      '{fieldName} should be at most {maximumLength} characters long.',

    fieldMinLength:

      '{fieldName} must be at least {minimumLength} characters long.',

    nameMinLength: '{fieldName} must be at least {minimumLength} characters long.',

    nameMaxLength: '{fieldName} must be at most {maximumLength} characters long.',

    streetField: '{fieldName} can only contain letters, spaces, hyphens, and apostrophes (no numbers or symbols)',

    houseNumberField: '{fieldName} must start with a number and may contain an optional letter suffix (e.g. 12A)',

    cityField: '{fieldName} can only contain letters, spaces, hyphens, and apostrophes',

    cityMaxLength: '{fieldName} must be at most {maximumLength} characters long',

    streetMinLength: '{fieldName} must be at least {minimumLength} characters long',

    streetMaxLength: '{fieldName} must be at most {maximumLength} characters long',

    houseNumberMinLength: '{fieldName} must be at least {minimumLength} character long',

    houseNumberMaxLength: '{fieldName} must be at most {maximumLength} characters long',

    houseNumberFormat: '{fieldName} must start with a digit (e.g. 12, 12A, 12/3, or 12-14)',

    nameAddressField: '{fieldName} can only contain letters, spaces, hyphens, and apostrophes',

    nameAddressMinLength: '{fieldName} must be at least {minimumLength} characters long',

    nameAddressMaxLength: '{fieldName} must be at most {maximumLength} characters long',

    formatField: '{fieldName} has an invalid format.',

    phoneNumericOnly: '{fieldName} must contain only numbers (no spaces or symbols)',

    phoneLengthInvalid: '{fieldName} must be {min}-{max} digits',

    postalCodeLength: '{fieldName} must be {requiredLength} digits for the selected country',
    passwordPattern: '<div>Password must meet the minimum requirements:<br/><ul><li>One lowercase letter</li><li>One uppercase letter</li><li>One number</li><li>At least one special character (&#64;$!%*?&)</li><li>At least 8 characters</li></ul></div>',
    passwordProhibitedChar: 'Please only use these special characters: {allowedChars}',
    minimumAge: 'You must be at least 18 years old to proceed.',

    securityQuestionRequired: 'You must answer one security question from the dropdown and create a custom security question with its answer',

    businessNameRequired: 'You must update your business name to continue',

    businessNameAndSecurityQuestionRequired: 'You must provide both a business name and answer at least one security question',

    stepRequirementsHeader: 'To continue, please complete the following:',

    directDepositRequired: 'Direct Deposit is required',

    authorizedToWorkRequired: 'You must confirm that you are authorized to work in France',

    siretWarning: 'Pampered Chef will not be able to pay commissions until a SIRET number has been provided.',

    contractAgreementRequired: 'You must accept the business practices and code of ethics to continue',

    vatNumberFormat: 'French VAT number must start with FR followed by 11 characters (e.g., FR12345678901)',

    vatNumberFormatATDE: 'VAT number must be in German format (DE + 9 digits) or Austrian format (ATU + 8 digits)',

    ibanFormat: 'IBAN format is invalid. Please check the country code and length.',

    ibanFormatFR: 'French IBAN must be 27 characters (FR + 25 digits)',

    ibanFormatDE: 'German IBAN must be 22 characters (DE + 20 digits)',

    ibanFormatAT: 'Austrian IBAN must be 20 characters (AT + 18 digits)',

    bicFormat: 'BIC must be 8 or 11 characters with valid country code',

    consultantEmailNotAllowed: 'This email address is already associated with a consultant account and cannot be used for kit checkout.',
    consultantOwnEmailNotAllowed: 'This is your own email address. Please enter the customer\'s email address.',
    invalidDateFormatExample: 'Invalid date format. Please use dd/MM/yyyy format (e.g., {example})',

  },

  errors: {

    loadingSecurityQuestions: 'Error loading security questions. Please try again.',

    savingSecurityResponses: 'Error saving security responses. Please try again.',

    loadingCountryCode: 'Error loading country information. Please try again.',

    savingBankDetails: 'Error saving bank details. Please try again.',

    updatingBusinessName: 'Error updating business name. Please try again.',

    businessNameAlreadyExists: 'The business name already exists. Please choose another.',

    savingFrenchContribution: 'Error saving French contribution information. Please try again.',

    loadingFrenchContribution: 'Error loading French contribution information. Please try again.',

    governmentIdInvalid: 'The provided SSN or SIRET number is invalid. Please verify and correct your information.',

    loadingContractTerms: 'Error loading contract terms. Please try again.',

    savingContractAgreement: 'Error saving contract agreement. Please try again.',

    savingVatInformation: 'Error saving VAT information. Please try again.',

    loadingVatInformation: 'Error loading VAT information. Please try again.',

    wizardCompletionFailed: 'Error registering wizard completion. Your account has been set up, but there was an issue with the final step.',

    loadingCampaignTypes: 'Error loading marketing campaign types. Please try again.',

    userNotAuthenticatedOrInvalidBeeNumber: 'User not authenticated or invalid BEE number',

    userNotAuthenticatedOrInvalidBusinessGuid: 'User not authenticated or invalid business GUID',

    failedToSaveSecurityResponses: 'Failed to save security responses',

    failedToSaveBankDetails: 'Failed to save bank details',

    failedToSaveFrenchContributionData: 'Failed to save French contribution data',

    unableToGetAuthenticatedUserBeeNumber: 'Unable to get authenticated user BEE number',

    noShippingAddressFoundInAddressBookEntry: 'No shipping address found in address book entry',

    noAddressBookEntryFoundForHostEmail: 'No address book entry found for host email',

    unableToGetBeeNumber: 'Unable to get bee number',

    noReportIdSpecified: 'No report ID specified',

    noConsultantDataReceived: 'No consultant data received',

    invoiceIsCanceled: 'Invoice Is Canceled',

    missingBeeNumberToken: 'Email verification token is missing.',

  },

  messages: {

    securityQuestionsSaved: 'Your security questions have been saved.',

    bankDetailsSaved: 'Your bank details have been saved successfully.',

    wizardCompleted: 'Account setup completed successfully!',

    businessNameUpdated: 'Your business name has been updated successfully.',

    frenchContributionSaved: 'Your French contribution information has been saved successfully.',

    contractAgreementSaved: 'Your contract agreement has been saved successfully.',

    vatInformationSaved: 'Your VAT information has been saved successfully.',

    emailAddressVerified: 'Thank you for verifying your email address.',

  },

  actions: {

    Save: 'Save',

    TryAgain: 'Try Again',

    UpdateBusinessName: 'Update Business Name',

    AcceptAndContinue: 'Accept and Continue',

  },

  security_question_1: 'What was your childhood nickname?',

  security_question_2: 'In what city or town did you meet your spouse/significant other?',

  security_question_3: 'What is the name of your favorite childhood friend?',

  security_question_4: 'What street did you live on in third grade?',

  security_question_5: 'What is your oldest sibling\'s birthday month and year? (e.g., January 1970)',

  security_question_6: 'What is the middle name of your youngest child?',

  security_question_7: 'What is your oldest sibling\'s middle name?',

  security_question_8: 'What school did you attend for sixth grade?',

  security_question_9: 'What was the name of your first stuffed animal?',

  security_question_10: 'In what city or town did your mother and father meet?',

  PROMOTIONPROGRESS_PSV_MESSAGE: 'You\'re {0} away from reaching the next level!',

  routes: {

    CountryList: 'Country List',

    CountryEdit: 'Country Edit',

    DocumentTemplateList: 'Document Template List',

    DocumentTemplateEdit: 'Document Template Edit',

    DocumentTemplateCultureSpecificList:

      'Culture Specific Document Template List',

    DocumentTemplateCultureSpecificEdit:

      'Culture Specific Document Template Edit',

    Home: 'Home',

    Logout: 'Logout',

    LocaleChanger: 'Locale Changer',

    Setup: 'Setup',

    StateList: 'State List',

    StateEdit: 'State Edit',

    Welcome: 'Welcome',

    Checkout22: 'Checkout 21',

  },

  address: {

    AddressLines: 'Address',

    City: 'City',

    Country: 'Country',

    Name: 'Name',

    PostalCode: 'Postal Code',

    State: 'State',

    Street2: 'Address Line 2',

    HouseNumber: 'House Number',

    Street: 'Street',

    NameRequired: 'Name is required',

  },





  buttons: {

    Back: 'Back',

    Continue: 'Continue',

    Edit: 'Edit',

    Okay: 'Okay',

    Delete: 'Delete',

    Yes: 'Yes',

    No: 'No',

    Add: 'Add',

    Filter: 'Filter',

    Clear: 'Clear',

    Apply: 'Apply',

    Save: 'Save',

    Exit: 'Exit',

    StateList: 'State List',

    DocumentTemplateCultureSpecificList:

      'Culture Specific Document Template List',

    Html: 'Html',

    Raw: 'Raw',

    UseCoupon: 'Use a coupon',

    ApplyCoupon: 'Apply coupon',

    RemoveCoupon: 'Remove coupon ({0})',

    CareerPlan: 'Career Plan',

    MyParties: 'My Parties',

    TrainingVideos: 'Training Videos',

    MyTeam:  'Team Overview',

    AddCardToWallet: 'Add Card To Wallet',

    Cancel: 'Cancel',

    Close: 'Close',

    Previous: 'Previous',

    Next: 'Next',

    Retry: 'Retry',

    Submit: 'Submit',

  },

  accessibility: {

    required: 'required',

  },

  labels: {

    Dash: '-',

    Actions: 'Actions',

    Add: 'Add',

    AddToCart: 'ADD TO CART',

    SelectOption: 'Select an option',

    SelectValue: 'Select a value',

    PricePerUnitWeight: {

      Weight: '{0} g',

      PricePerUnit: '({0}/kg)',

    },

    options: {

      VAT: 'VAT',

      TAXID: 'TAXID',

      RCS: 'RCS',

      VDI: 'VDI',

      France: 'France',

      Canada: 'Canada',

      Belgique: 'Belgium',

      Suisse: 'Switzerland',

      Allemagne: 'Germany',

      Espagne: 'Spain',

      RoyaumeUni: 'United Kingdom',

      EtatsUnis: 'United States',

      PageSize5: '5',

      PageSize10: '10',

      PageSize15: '15',

      PageSize20: '20',

      PageSize25: '25',

      PageSize50: '50',

      PageSize100: '100',

      PageSize175: '175',

      Show10: 'Show 10',

      Show15: 'Show 15',

      Show20: 'Show 20'

    },

    categoryPrefix: '--- ',

    DefaultLocation: 'Default Location',

    MonthToDate: 'Month to Date',

    YearToDate: 'Year to Date',

    CustomRange: 'Custom Range',

    VatInformationHeader: 'VAT Information',

    VatInformationSubHeader: 'Please provide your VAT information to complete your registration',

    VatType: 'VAT Number Type',

    VatNumber: 'VAT Number',

    VatNumberPlaceholder: 'Enter your VAT number (e.g., FR12345678901)',

    VatNumberPlaceholderATDE: 'Enter your VAT number (e.g., DE123456789 or ATU12345678)',

    VatNumberHelp: 'VAT number must start with FR followed by 11 characters',

    TaxIdNoInputRequired: 'No input required for TAXID',

    LoadingVatInformation: 'Loading VAT information...',

    ContractAgreementHeader: 'Consultant Contract Agreement',

    ContractAgreementSubHeader: 'Please review the business practices and code of ethics below before proceeding',

    LoadingContractTerms: 'Loading contract terms...',

    NoContractTerms: 'No contract terms available',

    Success: 'Success',

    Saving: 'Saving...',

    AutoCompleteLoading: 'Loading...',

    AutoCompleteNoResults: 'No results found',

    CheckingInventory: 'Checking inventory...',

    InStock: 'In Stock',

    BirthDate: 'Birth Date',

    FrenchContributionHeader: 'French Contribution Information',

    FrenchContributionSubHeader: 'Please provide the required information for French jurisdiction',

    EmployeeStatus: 'Employee Status',

    SSN: 'Social Security Number',

    SSNPlaceholder: 'Enter your 15-digit Social Security Number',

    SIRET: 'SIRET Number',

    SIRETPlaceholder: 'Enter your SIRET number',

    BirthCity: 'Birth City',

    BirthCityPlaceholder: 'Enter your birth city',

    BirthCountry: 'Birth Country',

    FrenchCitizen: 'I am a French citizen',

    AuthorizedToWork: 'I am authorized to work in France',

    LoadingFrenchContribution: 'Loading French contribution information...',

    LoadingSecurityQuestions: 'Loading security questions...',

    NoSecurityQuestions: 'No security questions available.',

    BusinessInfoHeader: 'Business Information',

    BusinessInfoSubHeader: 'Please provide your business information to complete your registration',

    BusinessName: 'Business Name',

    BusinessNamePlaceholder: 'Enter your business name',

    NewUserWizardHeader: 'Welcome to Your Account Setup',

    NewUserWizardSubHeader: 'Please complete the following steps to set up your account',

    SecurityQuestionsHeader: 'Security Questions',

    SecurityQuestionsSubHeader: 'Please answer at least one security question for account recovery',

    SecurityAnswerPlaceholder: 'Enter your answer',

    PersonalURL: 'Your Personal Website URL',

    BankDetailsHeader: 'Banking Information',

    BankDetailsSubHeader: 'Please enter your bank details to receive commission payments',

    BankAccountType: 'Bank Account Type',

    BankName: 'Bank Name',

    BankNamePlaceholder: 'Enter your bank name',

    BIC: 'BIC (Bank Identifier Code)',

    BICPlaceholder: 'Enter your BIC code',

    IBAN: 'IBAN',

    IBANPlaceholder: 'Enter your IBAN',

    DirectDeposit: 'I authorize direct deposit for commission payments',

    OPA: 'OPA (Optional)',

    LoadingBankDetails: 'Loading banking information...',

    Cancel: 'Cancel',

    CardHolderName: 'Card holder name',

    CardNumber: 'Card number',

    CardExpirationDate: 'Expiration date',

    CardSecurityCode: 'CVV',

    CheckoutContinue: 'Continue',

    CheckoutPlaceOrder: 'Place Order',

    NewCheckoutPlaceOrder: 'Place Order',

    BecomeAConsultant: 'Become A Consultant',

    CheckoutReEnterAddress: 'Re-enter Address',

    CheckoutUseSelectedAddress: 'Use Selected Address',

    CreateAccount: 'Create Account',

    Confirm: 'Confirm',

    Language: 'Language',

    ChooseLanguage: 'Select language',

    Country: 'Country',

    ChooseCountry: 'Choose your country',

    DropDownListPlaceholder: 'Select a {value}',

    EmailMoreInfoCheckbox: 'I\'d like to get emails about products, recipes, special offers, and sales.',

    ExitImageOverlay: 'Click Image to zoom out',

    Filter: 'Filter',

    GridNoRecords: 'No records found',

    Logout: 'Logout',

    Okay: 'Okay',

    RegistrationHeader: 'Create an Account',

    SameAsBillingCheckbox: 'Use this address as my billing information',

    Search: 'Search',

    SearchForProduct: 'Use product name, sku or keyword to search',

    SearchKeyword: 'Search by Keyword',

    SearchPlaceHolder: 'Search for product by name or code',

    ShowMore: 'Show More Results',

    ShowLess: 'Show Less',

    NoResultsFound: 'No results found',

    View: 'View',

    Error: 'Error',

    Loading: 'Loading',

    MarketingOptIn: 'Data processing for advertising purposes',

    // Marketing Opt-In Campaign Labels (format: MarketingOptIn_{codeId}_Content)

    MarketingOptIn_NEWSLETTER_Content: '<span class="marketingconent"><p>Ich möchte zukünftig über Trends, Schnäppchen, Gutscheine, Aktionen und Angebote der Pampered Chef Österreich per E-Mail informiert werden.</p><br>    <p>Deine Einwilligung zu diesen Aktivitäten kannst du jederzeit und kostenlos widerrufen. Weitere Informationen darüber, wie wir deine personenbezogenen Daten verarbeiten und wie du deine Zustimmung widerrufen kannst, findest du in unserer Datenschutzerklärung</p></span>',

    MarketingOptIn_MARKETING_Content:  '<span class="marketingconent"><p>Ich möchte zukünftig über Trends, Schnäppchen, Gutscheine, Aktionen und Angebote der Pampered Chef Österreich per E-Mail informiert werden.</p><br>    <p>Deine Einwilligung zu diesen Aktivitäten kannst du jederzeit und kostenlos widerrufen. Weitere Informationen darüber, wie wir deine personenbezogenen Daten verarbeiten und wie du deine Zustimmung widerrufen kannst, findest du in unserer Datenschutzerklärung</p></span>',

    Quantity: 'Quantity',

    FreeProductQuantityPrefix: '{quantity}x ',

    PaymentInfoPlaceholder: 'Payment information will appear here',

    SkuPrefix: 'SKU: {sku}',

  },

  consultantOrderEntry: {

    CartSummaryHeader: 'Cart Summary',

    ProceedToCheckout: 'Proceed to Checkout',

    SubmitButton: 'Submit',

    ContinueShoppingButton: 'Continue Shopping'

  },

  consultantLocator: {

    welcomeHeader: "We've got your back!",

    teamJoiningHeader: "Whose Team Are You Joining?",

    searchByText: "Search your consultant by:",

    nameTab: "Name",

    locationTab: "Location",

    country: "Country",

    directSignupText: "If they do not know a consultant or just simply want to sign up w/ Home office direct check the box",

    directSignupError: "Unable to process direct signup. Please try again or contact support.",

    whyJoinConsultantQuestion: "Why do you need to join with a consultant?",

    whyJoinConsultantPersonal: "Why do I need to join with a consultant?",

    consultantTeamInfo: "When you select a consultant to join with, you're joining their team. They will help guide you and provide invaluable support in reaching your goals as a consultant.",

    experienceInfo: "We want to make sure you have a good experience as you sign up with Pampered Chef. We may use your contact information (or pass it along your consultant) to reach out and help you along your journey.",

    selectDifferentConsultant: "Select a Different Consultant",

    selectAndContinue: "Select & Continue",

    consultantsFound: "Consultants Found",

    noConsultantsFound: "No consultants found in this area. Please try a different zip code.",

    enterConsultantName: "Enter First or Last Name",

    enterZipCode: "Enter Zip Code",

    searchRadius: "Search radius",

    kilometers: "km"

  },



  cart: {

    CartHeader: 'Your Cart',

    Select: 'Select',

    Checkout: 'Checkout',

    ApplePayCheckout: 'Pay with',

    ApplePayImageAlt: 'Apple Pay',

    CompleteSet: 'Complete Your Set',

    ConnectHeader: 'Connect to consultant',

    ConnectSubHeader: 'Don\'t know a consultant? Find one in your area to support a local business owner.',

    ConsultantByName: 'By Name',

    ConsultantByLocation: 'By Location',

    ConsultantListHeader: 'Consultants near you',

    ContinueShopping: 'CONTINUE SHOPPING',

    FindConsultatHeader: 'Find a Consultant',

    FindConsultatSubHeader: 'Enter your consultant\'s first and last name, or search for a consultant near you.',

    FindParty: 'FIND A PARTY',

    FindPartyHeader: 'Find a Party',

    FindPartyConsultant: 'FIND A CONSULTANT',

    FindPartySubHeader: 'Enter the party host, the chairperson name, or the organization name.',

    GuestCheckout: 'Guest Checkout',

    GuestCheckoutSubHeader: 'You can checkout as a guest and create an account later.',

    HostedBy: 'Hosted By',

    InterestedInHosting: 'Interested in hosting a party?',

    InterestedInHostingLink: 'Learn More',

    NoFreeGift: 'No thanks, I don\'t want a free gift',

    NotOrderWithConsultant: 'I\'m not ordering with a consultant',

    NotSupported: 'Not Supported',

    OrderingWith: 'You are ordering with',

    OrderSummary: 'Order Summary',

    PlaceHolderConsultantName: 'Enter consultant name',

    PlaceHolderHost: 'Enter a party host, chairperson, or organization name',

    PlaceholderZipcode: 'Enter a zip code',

    RelatedProducts: 'Products You Might Like',

    RemoveParty: 'Remove Party',

    RemoveConsultant: 'Remove Consultant',

    SelectButton: 'Select',

    SelectedFreeGift: 'Selected',

    Shipping: 'Shipping',

    SignIn: 'Sign In',

    SignInSubHeader: 'Please sign in for a faster checkout and to apply your discounts and/or credits.',

    Subtotal: 'Subtotal',

    SystemKeyword: 'SystemKeyword',

    TaxCalc: 'Tax calculated at checkout',

    Total: 'Total TTC',

    ProductTotal: 'Product Total',

    DiscountTotal: 'Discount',

    UnderParty: 'Under',

    ViewCart: 'View Cart',

    WhereParty: 'Where',

    MustSelectPartyOrConsultant: 'You must select a party or consultant to continue.',

    MustSelectFreeProductOrOptOut: "Please select your free product or opt out before continuing.",

    ShowFreeGift: 'Show Free Gifts',

    EmptyCart: 'Your cart is empty',

    EmptyCartMessage: 'Start adding items to your cart to see them here.',

    CloseCart: 'Close cart',

    ProductImageAlt: 'Product image',
    NestedImageAlt: 'Additional product image',
    ViewNestedImage: 'View larger image for {skuName}',
    LegalWarrantyNotice: 'Test',
    ConsultantPhotoAlt: "Consultant's photo",
    ConsultantEmailAlt: "Consultant's email address",
    ConsultantPhoneAlt: "Consultant's phone number",
    ConsultantMobileAlt: "Consultant's mobile phone number",
    RemoveFromCart: 'Remove from cart',

    ItemRemovedFromCart: "'{skuName}' has been removed from your cart.",

    warnings: {

      RESTRICTED_ITEM_SHIPPING: "SKU '{skuCode}' is not available for the selected shipping method",

      RESTRICTED_ITEM: 'Some items in your cart have restrictions.',

      INVALID_SHIPPING_METHOD: 'The selected shipping method is not available for your address.',

      MINIMUM_ORDER_NOT_MET: 'Your order does not meet the minimum order requirement.',

      SkuShippingRestriction: "SKU '{SkuCode}' is not available for the selected shipping method",
      SkuNoLongerAvailable: "'{SkuName}' was removed from your cart because it's no longer available.",
      SkuNotAvailableForShippingCountry: "'{SkuName}' was removed from your cart because it isn't available in the country you're shipping to.",
    },

  },

  checkout: {

    AddressRequirementMessage: 'Fields marked with an asterisk (*) are required.',

    BillingAddressHeader: 'Billing Address',

    Checkout: 'Checkout',

    KitCheckout: 'Complete Sign-Up',

    CheckoutAddressValAddressEntered: 'Address Entered:',

    CheckoutAddressValError: 'Address Could Not Be Verified. Please re-enter your address or continue with the address you entered.',

    CheckoutAddressValHdr: 'We were unable to verify the address you entered.',

    CheckoutAddressValSubHdr: 'Please select an address from the list below or edit your address.',

    CheckoutAddressValVerifiedAddress: 'Verified Address Options:',

    CheckoutAddressValWarning: 'You must select a verified address to continue.',

    CheckoutEditStep: 'Edit',

    CheckoutPaymentHdrStep: '3. Payment',

    CheckoutOrderSummaryHdr: 'Order Summary',

    CheckoutShipping: 'Shipping',

    CheckoutShippingHdrStep: '2. Shipping',

    CheckoutSubHeader: 'Sign in for faster checkout and to apply your discounts and/or credits.',

    CheckoutSubHeaderRemainder: 'for faster checkout and to apply your discounts and/or credits.',

    CheckoutSubtotal: 'Subtotal',

    CheckoutTax: 'Tax',

    CheckoutTotal: 'Total',

    CheckoutTotalRegularPrice: 'Total Regular Price',

    CheckoutYourInformationHdrStep: '1. Your Information',

    CreditCartHeader: 'Credit Card Information',

    CreditCartSubmit: 'Submit',

    OrderSummaryYourOrder:'Your Order',

    OrderSummaryItem: 'Items',

    PaymentAmount: 'Charge Amount:',

    NotSuppoted: 'is not supported',

    OrderNumber: 'Order Number',

    Quantity: 'Quantity',

    paymentMethods: {

      TTGBraintree: 'Credit Card',

      TTGBraintreeAPM: 'EPS',

      TTGBraintreeFR: 'Credit Card',

      TTGBraintreeAT: 'Credit Card',

      TTGBraintreeDE: 'Credit Card',

      OPA: 'OPA',

      PayPal: 'PayPal',

      EPS: 'EPS',

    },

    transactionStates: {

      NotProcessed: 'Authorized',

      PreAuthorized: 'Pre-Authorized',

      Authorized: 'Authorized',

      Booked: 'Booked',

      Refunded: 'Refunded',

      Processed : 'Processed',

    },

  },

  eventList: {

    AddHost: 'Add the Host',

    AtHostAddress: 'At Host Address',

    AtNewAddress: 'At Different Address',

    CancelButton: 'Cancel',

    PreviousButton: 'Previous',

    ClosedEventButton: 'Closed',

    CreateEventButton: 'Create Event',

    CreateNewEvents: 'Create New Event',

    EmailAddress: 'Email Address',

    EventAddressError: 'Event address is required',

    EventCommission: 'Commission',

    EventConsultantError: 'Your session has expired, please login again',

    EventDate: 'Date',

    EventDateError: 'Event date is required',

    EventTimeError: 'Start time cannot be after end time',

    EventPastDateError: 'Event cannot be scheduled in the past',

    EventHostAddError: 'Host first name, last name, email and phone number are required',

    HostInfoError: 'Please fill in host first name, last name, and either phone or email',

    HostAddressError: 'Please fill in all host address fields',

    EventHostess: 'Host',

    EventId: 'Event',

    EventLocation: 'Location',

    EventEndTime: 'End',

    EventStartTime: 'Start',

    EventTitle: 'Name',

    EventTitleError: 'Event name is required',

    EventTotal: 'Total',

    FindHost: 'Find the Host',

    FindHostError: 'Please select a host',

    FirstName: 'First Name',

    HostAddress: 'Host Address',

    HostInformation: 'Host Information',

    IAmHost: 'I\'m the host',

    LastName: 'Last Name',

    MyEvents: 'My Events',

    NewEventButton: 'New Event',

    NewEventStep1: 'Step 1: Choose the type of event you want to create',

    NewEventStep2: 'Step 2: Choose the country in which the event will take place',

    NewEventStep3: 'Step 3: Choose the hostess of the event',

    NewEventStep4: 'Step 4: Choose the title and time of the event',

    NewEventStep5: 'Step 5: Choose the location of the event',

    NewEventStep6: 'What would you like to do next?',

    SaveAndFinish: 'Save and Finish',

    SaveAndFinishDescription: 'Save the event to your calendar and return to your account page.',

    HostPortal: 'Host Portal',

    HostPortalDescription: 'Save the event and go to the Host Portal. Choose a theme and send the host an email with access data.',

    InviteGuests: 'Invite Guests',

    InviteGuestsDescription: 'Save the event and go to guest management to add guests to the event.',

    NextButton: 'Next',

    OpenEventButton: 'Open',

    PhoneNumber: 'Phone Number',

    SearchButton: 'Search',

    SearchHost: 'Search your Address Book use first name, last name, email or phone number',

    EventStatus: 'Status',

    SearchEvents: 'Search events by name, ID, or hostess...',

    ClearSearch: 'Clear Search',

    NoEventsFound: 'No events found',

  },
  contactClasses: {
    Consultant: 'Consultant',
    Customer: 'Customer',
  },
  eventTypes: {

    Party: 'Party',

    InPersonEvent: 'In-Person Event',

    FacebookParty: 'Facebook Party',

    WhatsAppParty: 'WhatsApp Party',

    Unknown: 'Unknown',

  },

  openOrders:{

    OrderNumber: 'Order Number',

    EventId: 'Event ID',

    CustomerName: 'Customer Name',

    InvoiceNumber:  'Invoice Number',

    Amount: 'Amount',

    InvoiceStatus: 'Invoice Status',

  },

  eventManagement: {

    AddGuest: 'Add Guest',

    AddGuestButton: 'Add Selected Guests',

    FindGuestError: 'Please select at least one guest to add',

    DuplicateGuestError: 'This guest has already been added to the event',

    AddGuestCancelButton: 'Cancel',

    BreadCrumbPage: 'Party',

    CreateOrder: 'Create Order',

    DeleteButton: 'Delete',

    EmailAddress: 'Email Address',

    EventDate: 'Date',

    EventID: 'Event ID',

    EventInfo: 'Event Information',

    EventList: 'Home',

    EventEndTime: 'End Time',

    EventStartTime: 'Start Time',

    EventStatus: 'Event Status',

    EventTitle: 'Event Title',

    EventType: 'Event Type',

    EventWhen: 'When',

    EventWhere: 'Where',

    FindContact: 'Find Contact',

    FirstName: 'First Name',

    GuestInfo: 'Guest Information',

    GuestName: 'Name',

    GuestRole: 'Role',

    Guests: 'Guests',

    Hostess: 'Hostess',

    HostEmail: 'Host Email',

    HostName: 'Host Name',

    HostPhoneNumber: 'Host Phone',

    InviteOpened: 'Invite Opened',

    InviteVisited: 'Invite Visited',

    LastName: 'Last Name',

    MakeHost: 'Make Host',

    NewContact: 'New Contact',

    OrderTotal: 'Total / Due',

    PhoneNumber: 'Phone Number',

    PlaceOrder: 'Place Order',

    RSVP: 'RSVP',

    SaveButton: 'Save',

    SendEmail: 'Send Email',

    ViewReceipt: 'View Receipt',

    TransferButton: 'Transfer Event',

    SendEmailTo: 'Send Email To',

    EmailSubject: 'Email Subject',

    EmailBody: 'Email Body',

    Cancel: 'Cancel',

    Send: 'Send',

    // Host Portal Messages

    HostPortalHeader: 'Host portal',

    HostPortalStep1: 'Step 1: Configure the host portal',

    HostPortalStep2: 'Step 2: Create password',

    HostPortalStep3: 'Step 3: Send invitation',

    ChooseTheme: 'Choose the theme of the host portal',

    ImagePreview: 'Image preview on the topic:',

    PasswordPlaceholder: 'Enter password for host (e.g., Cooking Show1)',

    OptionalNote: 'Optional note:',

    CcMeOnEmails: 'CC me on all emails regarding the host portal',

    SendEmailButton: 'Send email',

    SavePortalSettings: 'Save portal settings',

    ViewHostDashboard: 'View Host Dashboard',

    HostPortalColumn: 'Host Portal',

    ManageHostPortal: 'Manage',

    ViewHostPortal: 'View',

    // Email Editor Messages

    EmailPreview: 'Email preview',

    To: 'To',

    From: 'From',

    Regarding: 'Regarding',

    SendInvitation: 'Send invitation',

    // Success Messages

    PortalSettingsSaved: 'Portal settings saved',

    InvitationEmailSent: 'Invitation email sent',

    // Default Values

    NoEmailTemplate: 'No email template available',

    // Error Messages

    CopyFailed: 'Failed to copy to clipboard',

    // Validation Messages

    EventDatePastError: 'Event date cannot be in the past',

    EventEndTimeBeforeStartError: 'End time cannot be before start time',

    InvalidEmailFormat: 'Please enter a valid email address',

    MissingRequiredFields: 'The following required fields are missing: {fields}',

    CannotCloseEventWithItemsTitle: 'Cannot Close Event',

    CannotCloseEventWithItemsMessage: 'This event cannot be closed because there are unsubmitted carts with items. Please ensure all carts are empty or submitted before closing the event.',

    CannotDeleteEventWithItemsTitle: 'Cannot Delete Event',

    CannotDeleteEventWithItemsMessage: 'This event cannot be deleted because there are unsubmitted carts with items. Please ensure all carts are empty or submitted before deleting the event.',

    CancelEventButton: 'Cancel',
    CancelEventConfirmTitle: 'Cancel Event',

    CancelEventConfirmMessage: 'Are you sure you want to cancel this event? The event will become read-only and its carts will be deactivated.',

    CloseEventButton: 'Close',

    BackButton: 'Back',

    CloseEventConfirmTitle: 'Close Event',

    CloseEventConfirmMessage: 'Are you sure you want to close this event? The event will become read-only.',

    // Cart URL Messages

    CartPageUrl: 'Shop Page URL',

    CartPageUrlUnavailable: 'Shop page URL is unavailable while your public store is disabled.',

    CopyCartUrl: 'Copy URL',

    Copied: 'Copied!',

    // Email Messages

    EmailSubjectAndBodyRequired: 'Please enter both email subject and body',

    GuestEmailNotAvailable: 'Guest email address is not available',

    EmailSentSuccessfully: 'Email sent successfully',

    EmailSendFailed: 'Failed to send email. Please try again.',

    PleaseCompleteAllFields: 'Please complete all required fields',

  },

  invoice: {

    CartNumber: 'Cart Number',

    Name: 'Name',

    Email: 'Email',

    Phone: 'Phone',

    EventName: 'Event Name',

    InvoiceHeader: 'Invoice Payment',

    InvoiceInstruction: 'Pay off remaining invoice for your order. <br/>Review your invoice below and use the Add Payment button to select a method of payment.',

    InvoiceNumber: 'Invoice Number',

    OrderDate: 'Order Date',

    OrderInformation: 'Order Information',

    OrderReference: 'Order Reference',

    ShippingAddress: 'Shipping Address',

    SubmitButton: 'Submit Payment',

    NewSubmitButton: 'JETZT KAUFPFLICHTIG BESTELLEN',

    EmailLabel: 'Email Address',

    EmailPlaceholder: 'Enter your email address',

    VerifyIdentityButton: 'Verify Identity',

    InvoiceNotFound: 'Invoice not found. Please check the invoice number and try again.',

    VerifyIdentityInstruction: 'Please enter your email address to verify your identity and access this invoice.',

    VerifyIdentityFailed: 'The email address does not match our records. Please try again.'

  },

  orderList: {

    AllOrderTypes: 'All Order Types',
    AllViews: 'All Orders',
    ApplyFilterButton: 'Apply Filter',

    BetweenAnd: 'And',

    ClearFilterButton: 'Clear Filter',

    searchPlaceholder: 'Search orders...',

    orderCount: '{count} Orders',

    CommissionableValue: 'CV',

    ColumnListHeader: 'Columns',

    ColumnListSubHeader: 'Activate and rearrange the columns you want to see in your order list',

    ColumnOperandBeginsWith: 'Begins with',

    ColumnOperandBetween: 'Between',

    ColumnOperandContains: 'Contains',

    ColumnOperandEquals: 'Equals',

    ColumnOperandGreaterThan: 'Greater than',

    ColumnOperandGreaterThanOrEqual: 'Greater than or equal to',

    ColumnOperandLessThan: 'Less than',

    ColumnOperandLessThanOrEqual: 'Less than or equal to',

    ColumnOperandNotEquals: 'Does not equal',

    ColumnOperandSelectColumn: 'Select Column',

    CreateRMA: 'Create RMA',

    Email: 'Email',

    ExportButton: 'Export',

    ExportFileName: 'MyOrders',

    FilterByColumn: 'Filter by Column Value',

    FilterByOrderType: 'Filter by Order Type',

    FilterByView: 'Look at',

    GridFilterHeader: 'Filter',

    GridFilterSubHeader: 'Apply filters to your order list',

    LastName: 'Last Name',

    MakeReturn: 'Create Return',

    MasterOrderId: 'Order Reference',

    NoColumnSelected: 'Select Column to Search',

    NoTrackingNumber: 'No Tracking Number Provided',

    OrderDate: 'Order Date',

    OrderId: 'Order Number',

    Orders: 'My Orders',

     AllOrders: 'All Orders',

    OrderTotal: 'Total',

    OrderType: 'Order Type',

    PaidView: 'Paid Orders',

    PlaceHolderSearchFilter: 'Search For',

    PlaceHolderSearchFilterDate: 'Search For Date',

    PlaceHolderSearchFilterNumber: 'Search For Number',

    PlaceHolderSearchFilterSecondDate: 'Search For Second Date',

    PlaceHolderSearchFilterSecondNumber: 'Search For Second Number',

    OrderSubHeader: 'Keep track of all your orders.',

    TrackingNumber: 'Tracking Number',

    UnpaidView: 'Unpaid Orders',

    ViewInvoice: 'View Invoice',

        Page: 'Page',

    Of: 'of',

    Previous: 'Previous',

    Next: 'Next'

  },



  parcelLab: {

    TrackingTitle: 'Package Tracking',

    Loading: 'Loading tracking information...',

    LoadError: 'Unable to load tracking information. Please try again later.',

    ViewFullTracking: 'View Full Tracking Details',

    TrackingNumber: 'Tracking Number',

    Status: 'Status',

    EstimatedDelivery: 'Estimated Delivery',

    Carrier: 'Carrier',

    InTransit: 'In Transit',

    Delivered: 'Delivered',

    OutForDelivery: 'Out for Delivery'

  },



  partyOrderEntry: {

    Actions: 'Delete',

    ActiveCartHeader: 'Active',

    AddGuestButton: 'Add Guest',

    BreadCrumbPage: 'Party Order Entry',

    BreadCrumbOrderSummary: 'Order Summary',

    BreadCrumbGuest: 'Guest',

    BreadCrumbHost: 'Host',

    BreadCrumbOrder: 'Order',

    AddGuestSectionHeader: 'Add Guest',

    ProductSubtotalByCategory: 'Product Subtotal by Category',

    PriceCategoryName: 'Category',

    SumTotalPrice: 'Total Price',

    Discount: 'Discount %',

    FinalSum: 'Final Sum',

    BuyingDiscount: 'Buying Discount',

    AddNewAddress: 'New Address',

    AddNewCustomerButton: 'Add New Customer',

    AddCustomerEmailButton: 'Add Existing Customer',

    Available: 'Available',

    BalanceHeader: 'Balance',

    BecomeConsultant: 'Interested in Becoming a Consultant',

    CancelHostingEvent: 'Cancel',

    CatalogEntry: 'Catalog',

    CatalogRetailPrice: 'Retail Price',

    CatalogYourPrice: 'Your Price',

    Category: 'Category',

    CategoryEntry: 'Category',

    CategoryEntryBuyingDiscountHeader: 'Buying Discount',

    CategoryEntryHeader: 'Select a Category',

    CategoryEntryItemHeader: 'Item #',

    CategoryEntryProductHeader: 'Product',

    CategoryEntryRetailHeader: 'Price',

    CategoryEntryUOMHeader: 'UOM',

    CategoryEntryYourPriceHeader: 'Your Price',

    ChangeAddressButton: 'Change',

    ChangeAddressNewAddress: 'New Address',

    ChangeAddressError: 'Please select an address',

    ChangeAddressPopupHeader: 'Change Consolidated Address',

    ChangeAddressPopupSubHeader: 'Pick an existing address from the list or enter a new address for the consolidated address',

    ConsolidatedAddress: 'Consolidated Address',

    ConsultantName: 'Consultant',

    ConsultantSummary: 'Consultant',

    CreditCartSubmit: 'Add Payment',

    CustomerNameHeader: 'Name',

    DetailsHeader: 'Item',

    DiscountHeader: 'Discount',

    DiscountSectionHeader: 'Discounts and Special Offers',

    EventDate: 'Event Date',

    EventId: 'Event',

    FreeDollarCoupons: 'You can apply some of your hostess dollars toward a coupon',

    FreeDollarCouponsBtn: 'Check out the coupons available',

    FreeDollarCouponsPopupHeader: 'Available Coupons',

    FreeDollarCouponsRemoveBtn: 'Remove Coupon',

    FreeDollarCouponsApplied: "You have chosen to receive the coupon '{description}' for {couponAmount}",

    FreeDollarItemSelect: "Select the item you wish to receive a free dollars discount on",

    InactivatingCartTitle: 'Inactivating Cart',

    InactivatingCartMessage: 'This action will clear selected cart and it will not be submitted with order.',

    InactivatingCartConfirm: 'Do you want to continue?',

    ReactivateCartHeader: 'Reactivate',

    ReactivateCart: 'Reactivate this cart',

    GridFooterTotal: 'Total',

    GuestListAdd: 'Guests (+)',

    GuestName: 'Guest',

    GuestOrderHeaderSectionHeader: 'Guest Order',

    Host: 'Host',

    HostAParty: 'Interested in Hosting a Party',

    HostOrderHeaderSectionHeader: 'Host Order',

    HostSummary: 'Host Summary',

    ItemEntry: 'Item Entry',

    ItemNotAvailable: 'Out of Stock',

    LowStock: 'Low Stock',

    MakePaymentTitle: 'Make Payment',

    MissingPricing: 'Pricing not available',

    NumberOfGuests: 'Guests',

    NumberOfGuestOrders: 'Guest Orders',

    PartyDate: 'Party Date',

    PaymentCharge: 'Amount',

    PaymentName: 'Name',

    PaymentReference: 'Reference',

    PaymentStatus: 'Status',

    PaymentType: 'Type',

    ProductImageHeader: 'Image',

    PSHeader: 'PS',

    Options: 'Options',

    OrderNumberHeader: 'Order #',

    OrderSummary: 'Order Summary',

    OrderSummaryBalanceDue: 'Balance Due',

    OrderSummaryDiscount: 'Discount',

    OrderSummaryDonations: 'Donations',

    OrderSummaryFees: 'Fees',

    OrderSummaryPaymentsMade: 'Payments Made',

    OrderSummaryProductSubtotal: 'Product Subtotal',

    OrderSummarySectionHeader: 'Order Summary',

    OrderSummaryShipping: 'Shipping',

    OrderSummarySubtotal: 'Subtotal',

    OrderSummaryTax: 'Tax',

    OrderSummaryTotal: 'Total',

    OutOfStock: 'Not Available',

    PartyOrderSummaryGuestOrdersSectionHeader: 'Guest Orders',

    PartyOrderSummaryHostOrdersSectionHeader: 'Host Order',

    PaymentHeader: 'Payments',

    PaymentSectionHeader: 'Payment Information',

    QuantityHeader: 'Qty',

    RetailHeader: 'Retail',

    SaveAddressButton: 'Save Address',

    SaveHostingEvent: 'Save',

    SelectDate: 'Choose Date to Host',

    ShipNowButton: 'Ship Now',

    ShipNowHoverTitleBalance: 'Balance due on cart',

    ShipNowHoverTitleNoItems: 'No items in cart',

    ShipNowHoverTitleNoPayment: 'No payments on cart',

    ShippingAddressTitle: 'Shipping Address',

    ShippingCostHeader: 'Shipping Cost',

    ShippingSectionHeader: 'Shipping Information',

    ShippingMethodsSectionHeader: 'Shipping Method',

    ShipMethodTypesTitle: 'Ship With',

    ShipToTypesTitle: 'Ship To',

    SingleLineEntry: 'Single Line',

    Step1AddGuestLabel: 'Step 1: Choose an option',

    Step2AddExistingGuestLabel: 'Step 2: Find the guest in your address book',

    Step2AddNewGuestLabel: 'Step 2: Fill in the guest information',

    StopSell: 'Sold Out',

    SubmitButton: 'Submit Party',

    SubTotalHeader: 'Subtotal',

    TotalHeader: 'Total',

    UpdateCartButton: 'Update Cart',

    ViewOrderReceipt: 'View order receipt',

    YourShoppingCart: 'Your Shopping Cart',

    NoResultsFound: 'No results found.',

    BackToEventManagement: 'Back to Event Management',

    ChangePartyDate: 'Change Party Date',

    HostingPartyOn: 'Interested in hosting a party on {date}'

  },

  payment: {

    CreateInvoiceButton: 'Invoice {0} {1}',

    InvoiceHeader: 'Send an Invoice',

    InvoiceIssueDate: 'Issue Date',

    InvoiceNumber: 'Invoice Number',

    InvoiceStatus: 'Invoice Status',

    InvoicePaymentEntry: 'Send an invoice to {0} {1} to collect payment. The customer will be offered multiple payment options at time of payment.',

    ResendInvoiceButton: 'Resend Invoice to {0} {1}',

    BankPaymentHeader: 'Pay with Bank Account',

    BankPaymentEntry: 'Make a payment using your bank account, {0} {1}.',

    YourBankDetails: 'Your Bank Details',

    AccountHolder: 'Account Holder',

    AccountNumber: 'Account Number',

    RoutingNumber: 'Routing Number',

    PaymentAmount: 'Payment Amount',

    PayWithBank: 'Pay with Bank Account',

    Processing: 'Processing...',

    NoBankDetailsFound: 'No bank details found. Please add your bank details to use this payment method.',

  },

  productReview: {

    AddReviewButton: 'Add Review',

    EditReviewButton: 'Edit Review',

    CompleteHeader: 'Thank you!',

    CompleteSubHeader: 'Your review has been submitted and will be posted once approved.',

    CreateReview: 'Create Review',

    ErrorHeader: 'Error!',

    ErrorFileSize: 'Please check the size of the files you are attaching, they maybe too big.',

    ErrorLoggedIn: 'You must be logged in to create a review',

    ErrorReviewComment: 'Comment is required',

    ErrorOverallRating: 'Rating is required',

    ErrorSubHeader: 'Your review has not been submitted.',

    OverallRating: 'Overall Rating',

    Review5Star: 'Excellent',

    Review4Star: 'Good',

    Review3Star: 'Average',

    Review2Star: 'Below Average',

    Review1Star: 'Poor',

    ReviewAnonymous: 'Have review appear as Anonymous, if not checked your name will display with your review',

    ReviewAttachment: 'Add a photo or video',

    ReviewByAnonymous: 'Anonymous',

    ReviewComment: 'Add a written review',

    ReviewPending: 'Review pending approval',

    CommentPlaceholder: 'What did you like or dislike? What did you use this product for?',

    ReviewImageAlt: 'Product review image',

    ReviewHeader: 'Reviews',

    ReviewSubmit: 'Submit Review',

    ReviewTotalPart1: 'of',

    ReviewTotalPart2: 'reviews',

    ClickToUpload: 'Click to select files or drag and drop',

    SupportedFormats: 'JPEG, PNG, JPG, GIF, MP4',

    RemoveFileTitle: 'Remove file',

    Uploaded: 'Uploaded',

    Failed: 'Failed',

    ExistingAttachments: 'Current Photos & Videos',

    DeleteAttachment: 'Delete this attachment',

    Delete: 'Delete',

    DeleteAttachmentConfirm: 'Are you sure you want to delete this attachment? This action cannot be undone.',

    ErrorDeletingAttachment: 'Failed to delete attachment. Please try again.',

  },

  wishList: {

    CancelButton: 'Cancel',

    CreateList: 'Create a List',

    CreateListButton: 'Create List',

    PageHeader: 'My List',

    PlaceHolderWishListName: 'Enter a name for your list',

    WishListButton: 'My Wish List',

    WishListDetailHeader: 'My Wish Lists',

    WishListHeader: 'My Wish List',

    WishListItems: 'Items',

    WishListSaveTo: 'Save to',

    RemoveFromWishlist: 'Remove from Wishlist',

  },

  months: {

    0: 'January',

    1: 'February',

    2: 'March',

    3: 'April',

    4: 'May',

    5: 'June',

    6: 'July',

    7: 'August',

    8: 'September',

    9: 'October',

    10: 'November',

    11: 'December'

  },

  languages:{

    en: 'English',

    es: 'Spanish',

    fr: 'French',

    de: 'German',

    it: 'Italian',

    pt: 'Portuguese',

  },

  alerts: {

    AddedToCart: 'Added to cart!',

    AddToCartError: 'Add to Cart Error',

    NoQuantityAvailable: 'There is not enough in the warehouse to add more to cart',

    HostOnlyItemTitle: 'Host Only Item',

    HostOnlyItemMessage: 'This item is only available for host carts and cannot be added to a guest cart.',

    HostOnlyItemButton: 'Host Only',

    DiscountOnlyItemTitle: 'Discount Only Item',

    DiscountOnlyItemMessage: 'This item can only be added as part of a discount reward and cannot be added manually.',

    DiscountOnlyItemButton: 'Discount Only',

    NoProductsForCountry: 'No products are available for the selected country. Please contact customer service.',

    ValidationError: 'Validation Error',

    DeleteConfirmTitle: 'Delete',

    DeleteConfirm: 'Are you sure you want to delete: {0}',

    CannotBeUndone: 'This cannot be undone.',

    AOEEventNotCancellableException: {
      CartSubmitted: 'This event cannot be cancelled because a cart has been submitted.',
      CartHasPayments: 'This event cannot be cancelled because a cart has payments.',
    },

    AOEEventNotEmptyException: {
      OrdersExist: 'This event cannot be deleted because orders exist for it.',
      CartSubmitted: 'This event cannot be deleted because a cart has been submitted.',
      CartHasPayments: 'This event cannot be deleted because a cart has payments.',
      CartHasItems: 'This event cannot be deleted because a cart still has items.',
    },

    AOEEventNotClosableException: {
      CartHasItems: 'This event cannot be closed because a cart still has unsubmitted items.',
    },

    SfaEventNotCancellableException: {
      C: 'This event cannot be cancelled because it is already closed.',
      X: 'This event is already cancelled.',
      I: 'This event cannot be cancelled while an order submission is in progress.',
    },

    SfaEventNotDeletableException: {
      O: 'This event must be cancelled or closed before it can be deleted.',
      C: 'This event cannot be deleted.',
      I: 'This event cannot be deleted while an order submission is in progress.',
    },

    SfaEventReadOnlyException: {
      C: 'This event is closed and cannot be edited.',
      X: 'This event is cancelled and cannot be edited.',
    },

    SaveConfirmTitle: 'Save Successful',

    SaveConfirm: 'The changes on {0} have been saved successfully',

    NoPermissions: 'You do not have permissions to perform this action. ({0})',

    UnsavedChanges: 'You have unsaved changes. Do you want to save them?',

    Success: 'Success',

    InvoiceChange: 'Invoice Action',

    CancelInvoiceConfirm: 'Are you sure you want to cancel this invoice?',

    ResendInvoiceConfirm: 'Are you sure you want to resend this invoice?',

    InvoiceCancelled: 'Invoice has been cancelled successfully.',

    InvoiceResent: 'Invoice has been resent successfully.',

    FailedToCancelInvoice: 'Failed to cancel invoice. Please try again.',

    FailedToResendInvoice: 'Failed to resend invoice. Please try again.',

    CannotCancelInvoice: 'This invoice cannot be cancelled because it is already cancelled or paid.',

    CannotResendInvoice: 'This invoice cannot be resent because it is already cancelled or paid.',

    AOEPaymentMappingException: {

      CREDIT_CARD_NUMBER_MUST_BE_TEST_NUMBER:

        'Credit card number is not an accepted test number',

      DO_NOT_HONOR: 'Payment declined by card issuer',

      INSUFFICIENT_FUNDS: 'Insufficient funds',

      INVALID_NUMBER: 'Invalid card number',

    },

    CartSubmit : {

      UnknownError: 'The cart could not be submitted due to an unknown error',

      NotBalanced: 'The cart could not be submitted because the cart is unbalanced',

      SkuWarehouseNotFound: 'The cart could not be submitted because the warehouse for {SkuCode} was not found',

      SkuWarehouseNotAvailable : 'The cart could not be submitted because {SkuCode} is not available at the warehouse',

      SkuWarehouseStopSell : 'The cart could not be submitted because {SkuCode} is out of stock at the warehouse',

      ProductNotEligibleForPurchase: 'The cart could not be submitted because {SkuCode} is not permitted to be purchased',

      CouponAlreadyUsed: 'This coupon has already been used and cannot be applied again',

      ShippingAddressMissing: 'The cart could not be submitted because the shipping address is missing',

      ShippingMethodMissing: 'The cart could not be submitted because the shipping method is missing',
      CustomerInformationMissing: 'The cart could not be submitted because the customer name and email address are missing',
      SkuNotAvailableForShippingCountry: 'The cart could not be submitted because {SkuCode} is not available in the shipping country',
    },

    AOESkuWarehouseReservationCreateException: "The cart could not be submitted because one or more items are no longer available",

    AOEInvoiceCartNotFoundException: 'Invoice not found',

    AOECartInvoiceStatusInvalidException: 'The invoice can no longer be paid',

    PoeDiscCouponAlreadyUsedException: 'This coupon has already been used and cannot be applied again',

    GeneralError: 'An error occurred while processing your request ({messageKey})',

    AOESkuShippingRestrictionException: "SKU '{skuCode}' is not available for the selected shipping method",
    AOESkuNotAvailableForShippingCountryException: "SKU '{skuCode}' is not available in the country you're shipping to",
    AOECountryShippingRestrictionException: "The selected shipping method is not available for country '{countryCode}'",

    AxiosError: 'An error occurred while processing your request: {message} ({name} {code})',

    FailedToGetCurrentBatchNumber: 'Failed to get current batch number.',

    BeeAddressBookUniqueConstraintException: 'Your address book already contains a person with this email address, please use find contact tab, and look them up by their email address to add person to this event',

    BeeAddressBookReferencedByEventException: 'This contact cannot be deleted because they are linked to one or more events. Please remove the contact from all events before deleting.',

    NotEmpty: "The field '{fieldName}' cannot be empty",

    MaximumLength: "The field '{fieldName}' has exceeded the maximum length of characters",

    PartyOrderSubmitSuccessTitle: 'Order Submitted Successfully',

    PartyOrderSubmitSuccess: 'Your order has been submitted successfully.',

    ShipNowSuccessTitle: 'Cart Submitted Successfully',

    ShipNowSuccess: 'Your cart has been submitted successfully. The order number is {0}',

    CartSubmitSuccessTitle: 'Success!',

    CartSubmitSuccess: 'Your cart has been submitted',

    SubmitInvoiceError: 'Your payment could not be submitted.',

    SubmitInvoiceErrorSubTitle: 'Your payment could not be submitted for the following reasons: {0}',

    SubmitInvoiceSuccess: 'Your payment has been submitted successfully',

    SubmitInvoiceSuccessWithOutOrder: 'Your payment has been submitted successfully. You will receive an email confirmation shortly. Your order will be processed once consultant has collected all payments for the party.',

    SubmitInvoiceSuccessWithOrder: 'Your payment has been submitted successfully. You will receive an email confirmation shortly. Your order has been processed.',

    ViewInvoiceError: 'This invoice cannot be viewed',

    ViewInvoiceErrorSubTitle: 'The invoice you are trying to view is not available.',

    DiscountPlanAwardRestrictedItemException:"The item you are trying to add is not available for this discount plan.",

    ChangeHostTitle:"Change the host",

    ChangeHostConfirm: 'Are you sure you want to change the host? ',

    ProductEligibilityQuantityGatewayException: 'You are exceeding the maximum quantity allowed for this product.',

    PoeDiscCouponNotFoundException: 'The coupon you are trying to use is invalid.',

    PoeDiscCouponDiscountPlanNotFoundException: 'The coupon you are trying to use is not invalid for this order.',

    SingleUseOrderLimitTitle: 'Order Limit Reached',

    SingleUseOrderLimitMessage: 'You have already placed an order. Only one Kit Enhancement order is allowed.',

  },

  accountInfo: {

    title: 'Account management',

    orderHistory: {

      title: 'Order History',

      description: 'View your past orders and track shipments',

      updateTitle: 'Order History',

      updateDescription: 'View and manage your order history here.',

      loadError: 'Failed to load order history',

      errorLoading: 'Error loading order history. Please try again.',

      ordersFound: 'Found {count} orders',

      orderNumber: 'Order Number',

      orderDate: 'Order Date',

      orderType: 'Order Type',

      customer: 'Customer',

      tracking: 'Tracking',

      commissionValue: 'Commission Value',

      noOrders: 'No Orders Found',

      noOrdersDescription: 'You have no orders in your history yet.',

      showingResults: 'Showing {start}-{end} of {total} results',

      itemsPerPage: 'Items per page',

      orderDetails: 'Order Details',

      orderInformation: 'Order Information',

      customerInformation: 'Customer Information',

      shippingInformation: 'Shipping Information',

      commissionInformation: 'Commission Information',

      orderTotal: 'Order Total',

      customerName: 'Customer Name',

      customerEmail: 'Customer Email',

      additionalDetails: 'Additional Details',

      detailsLoaded: 'Details Loaded',

      noDetailToken: 'Detailed information not available for this order',

      orderSummary: 'Order Summary',

      shippingCost: 'Shipping Cost',

      taxAmount: 'Tax Amount',

      orderTypeId: 'Order Type ID',

      productDetails: 'Product Details',

      skuCode: 'SKU Code',

      productName: 'Product Name',

      productImage: 'Product',

      quantity: 'Quantity',

      price: 'Price',

      lineTotal: 'Line Total',

      detailLoadError: 'Failed to load order details',

      orderStatus: 'Order Status',

      paymentDetails: 'Payment Details',

      subtotal: 'Subtotal',

      paymentMethod: 'Payment Method',

      paymentProcessed: 'Processed',

      paymentAuthorized: 'Authorized',

      paymentRefunded: 'Refunded',

      authCode: 'Auth Code',

      shippingTo: 'Ship To',

      shippingMethod: 'Shipping Method',

      discount: 'Discount',

      shippingAndHandling: 'Shipping & Handling',

      inTotal: 'IN TOTAL',

      billingAddress: 'Billing Address'

    },

    billingAddress: {

      title: 'Billing and Delivery Address',

      description: 'Update your billing and delivery address information',

      updateTitle: 'Update Billing and Delivery Address',

      updateDescription: 'This feature will be available soon. You will be able to update your billing and delivery address information here.',

      noAddressSet: 'No billing address set',

      change: 'Change',

      addNew: 'Add New',

      editAddress: 'Edit Address',

      addNewAddress: 'Add New Address',

      saveSuccess: 'Address saved successfully',

      saveError: 'Failed to save address',

      selectAddress: 'Select',

      currentBilling: 'Billing Address',

      currentShipping: 'Shipping Address',

      createNew: 'Create New Address',

      addressUpdated: 'Address updated successfully',

      updateError: 'Failed to update address',

      requiredFields: 'Please fill in the following required fields',

      billing: 'Billing',

      shipping: 'Shipping',

      noBillingAddress: 'No billing address',

      noShippingAddress: 'No shipping address',

      addBillingAddress: 'Add billing address',

      addShippingAddress: 'Add shipping address',

      deleteAddress: 'Delete address',

      deleteConfirmTitle: 'Delete Address?',

      deleteConfirmMessage: 'Are you sure you want to delete this address? This action cannot be undone.',

      deleteSuccess: 'Address deleted successfully',

      deleteError: 'Failed to delete address',

      cannotDeleteTitle: 'Cannot Delete Address',

      cannotDeleteMessage: 'This address cannot be deleted because it is currently set as your {type} address. Please select a different address first.',

      defaultBadge: 'Default'

    },

    contactDetails: {

      title: 'Change e-mail, password and contact details',

      description: 'Update email address, password and contact details',

      updateTitle: 'Contact Information',

      updateDescription: 'Manage your email address, password, and other contact information.',

      changeEmailPassword: 'Change email and password',

      currentPassword: 'Current password *',

      currentPasswordPlaceholder: 'Enter your current password',

      currentPasswordRequired: 'Current password is required',

      currentPasswordTooShort: 'Current password must be at least 8 characters',

      newPassword: 'New password',

      newPasswordPlaceholder: 'Enter new password',

      newPasswordRequired: 'New password is required',

      newPasswordTooShort: 'New password must be at least 8 characters',

      newPasswordWeak: 'Password must contain uppercase, lowercase, number and special character',

      newPasswordSameAsCurrent: 'New password must be different from current password',

      confirmPassword: 'Confirm new password',

      confirmPasswordPlaceholder: 'Confirm your new password',

      confirmPasswordRequired: 'Please confirm your new password',

      passwordsDoNotMatch: 'Passwords do not match',

      passwordChangeSuccess: 'Password changed successfully',

      passwordChangeError: 'Failed to change password. Please check your current password.',

      accountDetailsSuccess: 'Account details saved successfully',

      accountDetailsError: 'Failed to save account details. Please try again.',

      passwordChangeTitle: 'Password',

      changePassword: 'Change Password',

      securityQuestionsTitle: 'Security Questions',

      securityQuestionsInfo: 'At least 1 question must be answered to save:',

      question1: 'What can I see is that:',

      question2: 'What can I see is that:',

      question3: 'What can I see is that:',

      securityAnswerPlaceholder: 'Enter your answer',

      accountDetailsTitle: 'Account Details',

      firstName: 'First name',

      firstNamePlaceholder: 'Enter your first name',

      lastName: 'Last name',

      lastNamePlaceholder: 'Enter your last name',

      emailAddress: 'Enter your email address',

      emailAddressPlaceholder: 'Enter your email address',

      phoneCountry: 'Phone',

      phoneNumber: 'Phone Number',

      phoneNumberPlaceholder: '(123) 456-7890',

      mobileCountry: 'Mobile',

      mobileNumber: 'Mobile Number',

      mobileNumberPlaceholder: '(123) 456-7890',

      saveAccountDetails: 'Save Account Details',

      saveSecurityQuestions: 'Save Security Questions',

      securityQuestionsSuccess: "Changes saved successfully",

      securityQuestionsError: "Failed to save security questions. Please try again."

    },

    termsConditions: {

      title: 'General Terms and Conditions',

      description: 'View General Terms and Conditions',

      updateTitle: 'Terms and Conditions',

      updateDescription: 'Review the current General Terms and Conditions for your account.'

    },

    dataProvisions: {

      title: 'Privacy Policy',

      description: 'View privacy policy',

      updateTitle: 'Privacy Settings',

      updateDescription: 'Change Marketing Opt In Selections and manage your privacy preferences.',

      termsId: 'Global ID',

      contractName: 'Contract Name',

      version: 'Version',

      acknowledgedDate: 'Date Signed',

      deliveredOn: 'Delivered On',

      signByDate: 'Sign By Date',

      status: 'Status',

      statusAccepted: 'Accepted',

      statusDeclined: 'Declined',

      statusPending: 'Pending',

      noContracts: 'No Privacy Policy Found',

      noContractsDescription: 'You have no privacy policy or contracts available at this time.',

      errorNoUser: 'No authenticated user found',

      errorLoading: 'Error loading privacy policy. Please try again.'

    },

    marketingOptIn: {

      title: 'Marketing Opt In',

      description: 'Manage your marketing communication preferences',

      updateTitle: 'Marketing Preferences',

      updateDescription: 'Choose which marketing communications you would like to receive.',

      errorLoading: 'Failed to load marketing preferences',

      errorSaving: 'Failed to save marketing preferences',

      errorNoUser: 'No user information available',

      saveSuccess: 'Marketing preferences saved successfully',

      noChangesToSave: 'No changes to save',

      optedIn: 'Opted In',

      optedOut: 'Opted Out',

      lastModified: 'Last Modified',

      noOptionsTitle: 'No Marketing Options Available',

      noOptionsDescription: 'There are currently no marketing communication options available for your account.'

    },

    personalData: {

      title: 'Request personal data',

      description: 'Request a copy of your personal data or request deletion',

      updateTitle: 'Personal Data Request',

      updateDescription: 'Request your personal data or account deletion. We will process your request according to applicable privacy laws.',

      selectRequest: 'Select your request:',

      exportData: 'Export personal data',

      deleteData: 'Delete personal data',

      emailAddress: 'Your email address (required):',

      emailPlaceholder: 'Enter your email address',

      sendRequest: 'Send request',

      emailRequired: 'Email address is required',

      emailInvalid: 'Please enter a valid email address',

      emailMismatch: 'The entered email is invalid.',

      optionRequired: 'Please select a request option',

      exportSuccess: 'Your data export request has been submitted successfully. You can now download your personal data report.',

      deleteSuccess: 'Your data deletion request has been submitted successfully.',

      submitError: 'Failed to submit request. Please try again.',

      exportOptionsTitle: 'Your Personal Data Export',

      exportOptionsDescription: 'Your personal data export request has been processed. You can download the report as a PDF.',

      downloadPDF: 'Download PDF Report',

      viewReport: 'View Report',

      reportTitle: 'Personal Data Export Report',

      newRequest: 'Make New Request',

      pdfNoProfileDataError: 'No profile data available. Please try submitting the request again.',

      pdfNoAddressDataError: 'Address data not loaded. Please try submitting the request again.',

      pdfComponentNotReadyError: 'PDF export component not ready. Please try again.',

      pdfDownloadFailedError: 'PDF download failed. Please try again or use your browser\'s print function.',

      // Report content translations

      reportHeader: 'Export of Personal Data',

      businessInformation: 'Business Information:',

      personalInformation: 'Personal Information:',

      contactInformation: 'Contact Information:',

      phoneNumbers: 'Phone Numbers:',

      addresses: 'Addresses:',

      governmentIds: 'Government IDs:',

      governmentIdType: 'ID Type:',

      taxPayerIdLastFour: 'Last Four Digits:',

      noGovernmentIdsOnFile: 'No government IDs on file.',

      customerNumber: 'Customer Number:',

      dateOfBirth: 'Date of Birth:',

      username: 'Username:',

      anniversary: 'Anniversary:',

      name: 'Name:',

      social: 'Social:',

      firstName: 'First Name:',

      lastName: 'Last Name:',

      preferredName: 'Preferred Name:',

      alternativeFirstName: 'Alternative First Name:',

      alternativeLastName: 'Alternative Last Name:',

      webUrl: 'Web-URL:',

      imHandle: 'IM Handle:',

      facebook: 'Facebook:',

      twitter: 'Twitter:',

      linkedIn: 'LinkedIn:',

      pinterest: 'Pinterest:',

      reportEmailAddress: 'Email Address:',

      home: 'Home',

      mobile: 'Mobile',

      fax: 'Fax',

      work: 'Work',

      shippingAddress: 'Shipping Address',

      billingAddress: 'Billing Address',

      mailingAddress: 'Mailing Address',

      addressName: 'Name:',

      company: 'Company:',

      addressLine1: 'Address Line 1:',

      addressLine2: 'Address Line 2:',

      city: 'City:',

      stateProvince: 'State/Province:',

      postalCode: 'Postal Code:',

      country: 'Country:',

      noAddressesOnFile: 'No addresses on file.',

      reportFooterText: 'Personal Data Export Report - Generated on',

      requestType: 'Request Type: Data Export',

      notAvailable: 'N/A'

    },

  },

  columns: {

    birthDate: 'Birth Date',

    birthDatePlaceholder: 'Day/Month/Year',

    countryCode: 'Country Code',

    country: 'Country Name',

    currencyId: 'Currency',

    state: 'State Name',

    countryCodeIsoalpha3: 'ISO 3',

    isEnabled: 'Enabled',

    templateName: 'Template Name',

    templateDescription: 'Description',

    schemaName: 'Schema Name',

    cultureName: 'Culture Name',

    messageBody: 'Message Body',

    documentName: 'Document Name',

    documentSubject: 'Document Subject',

    codeIdClassification: 'Classification',

    firstName: 'First Name',

    lastName: 'Last Name',

    emailAddress: 'Email',

    password: 'Password',

    confirmPassword: 'Confirm Password',

    phone: 'Phone Number',

    city: 'City',

    addressLine1: 'Street Address',

    addressLine2: 'Apt, Suite, etc',

    stateCode: 'State/Province',

    postalCode: 'Postal Code',

    addressFirstName: 'First Name',

    addressLastName: 'Last Name',

    title: 'Title',

    companyName: 'Company',

    primaryPhone:

    {

      number: 'Phone Number'

    },

    mobilePhone:

    {

      number: 'Mobile Number'

    },

    primaryPhoneNumber: 'Phone Number',

    alt1PhoneNumber: 'Alt Phone Number',

    alt2PhoneNumber: 'Alt Phone Number',

    alt3PhoneNumber: 'Alt Phone Number',

    preferredName: 'Preferred Name',

    billingFirstName: 'First Name',

    billingLastName: 'Last Name',

    facebookId: 'Facebook',

    linkedInId: 'LinkedIn',

    twitterId: 'Twitter',

    pinterestId: 'Pinterest',

  },

  terms: {

    checkoutAgreement: 'Mit Klick auf „Jetzt kaufpflichtig bestellen“ akzeptierst du die {termsLink}  und die  {privacyLink} und stimmst der Verarbeitung deiner Daten zur Bestellabwicklung zu',

    agreement: 'By clicking "become a consultant" you are agreeing to our {termsLink} and {privacyLink}',

    termsOfUse: 'Terms of Use',

    privacyPolicy: 'Privacy Policy',

    checkoutTermsOfUse: 'AGB',

    checkoutPrivacyPolicy: 'Datenschutzerklärung',

    certification: 'I certify that I am 18 years of age or older and have read and accept the terms of the {consultantAgreementLink}',

    independentConsultantAgreement: 'Independent Consultant Agreement',

    ethics: 'I accept and have read the H+BH {prohibitedBusinessPracticesLink} and {codeOfEthicsLink}',

    prohibitedBusinessPractices: 'Prohibited Business Practices',

    codeOfEthics: 'Code of Ethics',

    prohibitedBusinessPracticesUrl: 'https://pamperedchef.widen.net/s/qlznjrtpjk/prohibited-business-practices-deat',

    codeOfEthicsUrl: 'https://pamperedchef.widen.net/s/kzrsqxx6wm/berkshire-code-of-conduct-deat',

    showMore: 'Show More',

  },

  thankYou:

  {

    DetailsAboutOrder: 'Details about your order',

    DetailsHeader: 'Details',

    DiscountHeader: 'Discount',

    header: 'Thank you for your order!',

    orderNumber: 'Order number:',

    product: 'Product',

    productName: 'Name',

    quantity: 'Quantity',

    PageHeader: 'Thank You!',

    PaymentAmount: 'Payment Amount',

    price: 'Price',

    ProductImageHeader: 'Product',

    RetailHeader: 'Price',

    QuantityHeader: 'Qty',

    shippingCost: 'Shipping',

    SubHeader: 'Your order has been placed and will be processed shortly. <br/> We will send you a confirmation email confirmation shortly. <br/> Please read and accept the terms and conditions. <br/> <b>Shipping note:</b> To ensure the fastest possible shipping, you may recieve partial deliveries if you order multiple items.',

    SubTotalHeader: 'Subtotal',

    totalTaxAmountInclude: 'VAT',

    total: 'Total',

    YourItems: 'Your Items',

  },

  hostEventList: {

    Events: 'Events that you have hosted',

  },

  dashboard: {

    progress: {

      MyProgress: 'My Progress',

      Progress: 'Progress',

      ProgressInfo: 'Overview of the performance metrics.',

      MonthlyOverview: 'This Month',

      Overview: 'Overview',

      MonthlyProgressInfo: 'Overview of the performance this month.',

      TotalRecruitmentCount: 'Total Recruitment Count',

      CareerSales: 'Career Sales',

      UnsubmittedPartyOrder: 'Unsubmitted Party Orders',

      NextPromotionLevel: 'Next Promotion Level',

      NextPromotionProgress: 'You\'re {0} away from your next promotion level!',

      PromotionProgressText: 'You\'re {amount} away from reaching next level!',

      PersonalSalesRequirement: 'Personal Sales',

      TeamSignupsRequirement: 'Team Sign-ups',

      TeamTotalSalesRequirement: 'Team Total Sales',

      PersonalSalesProgressMessage: 'You\'re {amount} away from your next promotion level!',

      TeamSignupsProgressMessage: 'You need {amount} more sign-ups to reach your next level!',

      TeamTotalSalesProgressMessage: 'Your team needs {amount} more in sales to advance!',

      PROMOTIONPROGRESS_PSV: 'Personal Sales Volume',

      PROMOTIONPROGRESS_PSV_MESSAGE: 'You\'re {0} away from reaching the next level!',

      PROMOTIONPROGRESS_ACTIVELINES: 'Active Lines',

      PROMOTIONPROGRESS_ACTIVELINES_MESSAGE: 'You need {0} more active lines to reach the next level!',

      PROMOTIONPROGRESS_TEAMSALES: 'Team Sales',

      PROMOTIONPROGRESS_TEAMSALES_MESSAGE: 'Your team needs {0} more in sales to advance!',

      PROMOTIONPROGRESS_GEN1DIRECTORS: 'Gen 1 Directors',

      PROMOTIONPROGRESS_GEN1DIRECTORS_MESSAGE: 'You need {0} more Gen 1 Directors to reach the next level!',

      PROMOTIONPROGRESS_EXECDIRECTORTEAMS: 'Executive Director Teams',

      PROMOTIONPROGRESS_EXECDIRECTORTEAMS_MESSAGE: 'You need {0} more Executive Director Teams to advance!',

      PROMOTIONPROGRESS_ORGVOLUME: 'Organization Volume',

      PROMOTIONPROGRESS_ORGVOLUME_MESSAGE: 'Your organization needs {0} more in volume to reach the next level!',

      RequirementCompleted: 'Requirement completed! Congratulations!',

      MonthlyRecruitmentCount: 'Recruitment Count',

      MonthlySales: 'Monthly Revenue',

      MonthlyQV: 'Monthly Qualifying Volume',

      CommissionRate: 'Commission Rate',

      QV: 'PQP'

    },

    invoice: {

      orderNumber: 'Order Number',

      eventId: 'Event ID',

      customerName: 'Customer Name',

      invoiceNumber: 'Invoice Number',

      amount: 'Amount',

      status: 'Invoice Status',

      issueDate: 'Issue Date',

      reads: 'Reads',

      hints: 'Hints',

      title: 'Open Orders',

      description: 'Keep track of open invoices, cancel or resend invoices when needed.',

      allInvoices: 'All Invoices',

      read: 'Read',

      sent: 'Sent',

      Issued: 'Issued',

      NotPaid: 'Not Paid',

      Paid: 'Paid',

      GridFilterHeader: 'Filter Invoices',

      GridFilterSubHeader: 'Use the options below to filter the invoice list',

      FilterByStatus: 'Filter by Status',

      FilterByPeriod: 'Filter by Period',

      AllStatuses: 'All Statuses',

      AllPeriods: 'All Periods',

      Last30Days: 'Last 30 Days',

      Last60Days: 'Last 60 Days',

      Last90Days: 'Last 90 Days',

      CancelInvoice: 'Cancel Invoice',

      ResendInvoice: 'Resend Invoice',

      Resend: 'Resend',

      orders: 'orders',

      noInvoicesFound: 'No invoices found for the selected criteria.',

      Cancelled: 'Cancelled',

      Read: 'Read'

    },

    openParties: {

      title: 'Open Parties',

      description: 'Manage your upcoming parties and events.',

      parties: 'parties',

      CreateParty: 'Create Party',

      DaysTilParty: 'Days Until Party',

      NumberOfCarts: 'Number of Carts',

      ExternalOrders: 'External Orders',

      day: 'day',

      days: 'days'

    },

    incentives: {

      SUPERSTARTERINCENTIVEPROGRESS:

      {

        1: 'Description of the Super Starter Incentive - Level 1',

        2: 'Description of the Super Starter Incentive - Level 2',

        3: 'Description of the Super Starter Incentive - Level 3',

        4: 'Description of the Super Starter Incentive - Level 4',

        programDetails: '<div><b>Super Starter Program Details</b><p>Complete all levels to earn exclusive rewards and recognition!</p></div>',

        completeMsg:

        {

          1: 'Congratulations! You\'ve completed the Level 1!',

          2: 'Amazing work! You\'ve completed the Level 2!',

          3: 'Outstanding achievement! You\'ve completed the Level 3!',

          4: 'Outstanding achievement! You\'ve completed the Level 4!'

        }

      },

      TRIP2025INCENTIVEPROGRESS:

      {

        1: 'Description of the 2025 Trip Incentive - Silver',

        2: 'Description of the 2025 Trip Incentive - Gold',

        3: 'Description of the 2025 Trip Incentive - Platinum',

        programDetails: '<div><b>Provide program details in HTML format</b></div>',

        completeMsg:

        {

          1: 'You\'ve earned enough points to move up to the next level!',

          2: 'You\'ve earned enough points to move up to the next level!',

          3: 'You\'ve earned enough points to move up to the next level!'

        }

      },

      InqDsp_IncentiveCornerMSO:

      {

        1: 'Description of the Monthly Sales Offer - Level 1',

        2: 'Description of the Monthly Sales Offer - Level 2',

        3: 'Description of the Monthly Sales Offer - Level 3',

        programDetails: '<div><b>Provide program details in HTML format</b></div>',

        completeMsg:

        {

          1: 'You\'ve earned enough points to move up to the next level!',

          2: 'You\'ve earned enough points to move up to the next level!',

          3: 'You\'ve earned enough points to move up to the next level!'

        }

      },

      points: 'Points',

      travel: {

        title: 'Travel Incentive',

        points: 'Points',

        programDetails: 'Program Details'

      },

      status: {

        inProgress: 'In Progress',

        completed: 'Completed'

      }

    }

  },





  hostDashboard: {

    EventDetails: 'Party Details',

    Welcome: 'Welcome, {firstName}!',

    WelcomeSubTitle: 'In the host dashboard you can track your party success and rewards.',

    GuestActions: 'Guest actions',

    CurrentPartyTotal: 'Current Party Total',

    CurrentPartyTotalDescription: 'Total sales for your current party',

    ProductSales: 'Product Sales',

    ProductSalesDescription: 'Total product sales excluding tax and shipping',

    GuestList: 'Party Guest List',

    InvitationReminder: 'Send Invitation',

    ChangeStatus: 'Change Status',

    RemoveGuest: 'Remove Guest',

    EventRewards: 'My Rewards',

    AddGuest: "+ Guest",

    ImportGuests: 'Import Guests',

    Import: 'Import',

    AddGuestButton: 'Add',

    AddGuestCancelButton: 'Cancel',

    Invited: 'Guests',

    Attending: 'Orders',

    GuestName: 'Name',

    EmailAddress: 'Email',

    GuestOrderTotal: 'Order Total',

    CodeTextInvitationStatus: 'Status',

    TotalSales: 'Total Sales',

    OrderStatus: 'Order Status',

    OrderSubmitted: 'Submitted',

    OrderPending: 'Pending',

    NoRewardsYet: 'No rewards earned yet.',

    RewardsGuide: 'Rewards Guide',

    RewardsPdfUrl: 'https://ttgcommon-180003f.s3.eu-central-1.amazonaws.com/tpc/contentimages/032026_Neues-Gastgeber-Bonusprogramm_DEAT_RE28022026.pdf',

    GuestSales: 'Guest sales',

    GuestSalesLeftToReach: 'in guest sales left to reach your next reward level',

    AllRewardsEarned: 'You have reached all reward levels!',

    AboutRewardLevels: 'About reward levels',

    YourRewardsLevel: 'Your Rewards Level',

    ShopMyWishList: 'Shop My Wish List',

    ShopAll: 'Shop All',

    EnterPassword: 'Enter Password',

    PasswordRequired: 'Please enter the password to access the host dashboard.',

    PasswordPlaceholder: 'Password',

    InvalidPassword: 'Invalid password. Please try again.',

    HostPortalImage1: 'host-a-party-half-price-products.jpg',

    HostPortalImage2: 'de-cons-and-host.jpg',

    HostPortalImage3: 'boxes.jpg',

  },

  earnedDiscountToDescription:

  {

    Default: "{quantity} - {awardMessage}",

    DiscountedItem: "{awardDescription} ({awardMessage})",

    FreeProduct:  "{awardDescription} ({awardMessage})",

    SelectFreeProduct: "{appliedAmount} - {awardMessage}",

  },

  consultantCorner: {

    security: {

      passwordHeader: 'Change Password',

      passwordSubHeader: 'Update your account password for enhanced security',

      oldPasswordLabel: 'Current Password',

      oldPasswordPlaceholder: 'Enter your current password',

      newPasswordLabel: 'New Password',

      newPasswordPlaceholder: 'Enter your new password',

      confirmPasswordLabel: 'Confirm New Password',

      confirmPasswordPlaceholder: 'Confirm your new password',

      passwordRequirements: 'Password Requirements:',

      requirement1: 'At least 8 characters long',

      requirement2: 'At least one lowercase letter',

      requirement3: 'At least one uppercase letter',

      requirement4: 'At least one number',

      requirement5: 'At least one special character',

      savePassword: 'Save Password',

      saving: 'Saving...',

      oldPasswordRequired: 'Current password is required',

      newPasswordRequired: 'New password is required',

      newPasswordTooShort: 'Password must be at least 8 characters long',

      newPasswordWeak: 'Password does not meet the requirements',

      confirmPasswordRequired: 'Please confirm your new password',

      passwordsDoNotMatch: 'Passwords do not match',

      passwordSaveSuccess: 'Password updated successfully',

      passwordSaveError: 'Failed to update password. Please try again.'

    },

    reportDashboard: {

      defaultConsultantTitle: 'Executive Director',

      errors: {

        noPeriodDatesAvailable: 'No period dates available',

        currentPeriodNotFound: 'Current period not found',

      },

    },

    CongratulationsMessageStart: 'Congrats! You are getting paid at ',

    CongratulationsMessageEnd: ' this month.',

    leads: {

      MyLeads: 'My Leads',

      AllLeads: 'All Leads',

      leadCount: '{count} Leads',

      LeadSubHeader: 'Review and manage your leads',

      FirstName: 'First Name',

      LastName: 'Last Name',

      Email: 'Email',

      Phone: 'Phone',

      CreateDate: 'Created Date',

      Status: 'Status',

      Source: 'Source',

      searchPlaceholder: 'Search leads...',

      Loading: 'Loading...',

      Actions: 'Actions',

      Accept: 'Accept',

      Reject: 'Reject',

      Refer: 'Refer',

      ReferTo: 'Refer To',

      SelectConsultant: 'Select Consultant',

      NoConsultantsFound: 'No consultants found',

      ConfirmAccept: 'Are you sure you want to accept this lead?',

      ConfirmReject: 'Are you sure you want to reject this lead?',

      ConfirmRefer: 'Are you sure you want to refer this lead to the selected consultant?',

      LeadAccepted: 'Lead accepted successfully',

      LeadRejected: 'Lead rejected successfully',

      LeadReferred: 'Lead referred successfully',

      Cancel: 'Cancel',

      Confirm: 'Confirm',

      NoLeads: 'No leads found for this contact.',

      LeadType: 'Lead Type',

      DistSource: 'Distribution Source',

      AssignedDate: 'Assigned Date',

      Accepted: 'Accepted',

      Closed: 'Closed',

      Open: 'Open'

    },

    contacts: {

      title: 'My Contacts',

      allContacts: 'All Contacts',

      contactCount: '{count} contacts',

      filters: "Filters",

      filterTitle: "Filter Contacts",

      allClasses: "All Classes",

      allGroups: "All Groups",

      search: 'Search contacts...',

      classId: 'Class ID',

      group: 'Contact Group',

      applyFilters: 'Apply Filters',

      clearFilters: 'Clear Filters',

      filterSub: 'Apply filters to table data',

      manageContacts: 'Manage all your contacts.',

      searchPlaceholder: 'Search contacts...',

      addFilter: 'Add another filter...',

      searchHelp: 'Tip: Use name, email, or phone to filter by specific fields',

      newContact: 'New Contact',

      noContactsFound: 'No contacts found',

      addSuccess: 'Contact was successfully added!',

      updateSuccess: 'Contact was successfully updated!',

      addedSuccessfully: 'has been successfully added to your contacts.',

      viewContact: 'Click here to view contact',

      deleteConfirm: 'Are you sure you want to delete {email}?',

      sendEmail: 'Send Email',

      emailTo: 'To: {email}',

      emailSubject: 'Subject',

      emailMessage: 'Message',

      cancel: 'Cancel',

      send: 'Send',

      delete: 'Delete',

      firstName: 'First Name',

      lastName: 'Last Name',

      email: 'Email',

      phoneNumber: 'Phone Number',

      actions: 'Actions',

      edit: 'Edit'

    },

    addContact: {

      title: 'Add Contact',

      editTitle: 'Edit Contact',

      firstName: 'First Name',

      lastName: 'Last Name',

      preferredName: 'Preferred Name',

      email: 'Email',

      noEmail: 'No Email Address Available',

      phone: {

        primary: 'Primary Phone',

        type: 'Phone Type',

        numberPlaceholder: 'Enter phone number',

        alternative:' Alternative Phone',

        cell: 'Cell',

        work: 'Work',

        home: 'Home',

        other: 'Other',

      },

      address: {

        sameAsDelivery: 'Same as delivery address',

        billing: 'Billing Address'

      },

      requiredFieldsError: 'Please fill in all required fields (First Name, Last Name, Email)',

     addressRequiredFieldsError: 'Please fill in all required address fields (Address Line 1, City, Postal Code, Country, House Number)',

      phoneRequiredError: 'Please complete all primary phone fields (Country, Number, Type)',

      save: 'Save',

      cancel: 'Cancel'

    },

    socialMedia: {

      placeholders: {

        facebook: 'https://facebook.com/username',

        instagram: 'https://instagram.com/username',

        pinterest: 'https://pinterest.com/username',

        youtube: 'https://youtube.com/channel/username',

        tiktok: "https://tiktok.com/{'@'}username",

      },

    },

    contactDetails: {

      ContactDetails: 'Contact Details',

      UpdateContactInfo: 'Update your contact information',

      PageLoadError: 'Error loading contact details',

      SaveError: 'Error saving contact information',

      SaveErrorGeneric: 'An unexpected error occurred while saving your contact information. Please try again.',

      SaveSuccess: 'Contact information saved successfully',

      NetworkError: 'Network error occurred. Please check your connection and try again.',

      ValidationError: 'Please correct the validation errors and try again.',

      TryAgain: 'Try Again',

      LoadingContactDetails: 'Loading contact details...',

      CancelButton: 'Cancel',

      SaveContactInfo: 'Save Contact Info',

      Saving: 'Saving...',

      AccountInfo: 'Account Information',

      Username: 'Username',

      NameSection: 'Name Information',

      FirstName: 'First Name',

      LastName: 'Last Name',

      ContactInfo: 'Contact Information',

      EmailAddress: 'Email Address',

      PrimaryPhone: 'Landline',

      MobilePhone: 'Mobile',

      PhonePlaceholder: 'Enter phone number',

      FirstNameRequired: 'First name is required',

      LastNameRequired: 'Last name is required',

      EmailRequired: 'Email address is required',

      EmailInvalid: 'Please enter a valid email address',

      PhoneInvalid: 'Please enter a valid phone number'

    },

    editContact: {

      PageLoadError: 'An error occurred while loading the contact details.',

      EditContact: 'Edit Contact',

      EditContactDetails: 'Edit contact details here',

      Name: 'Name',

      SaveButton: 'Save',

      CancelButton: 'Cancel',

      SameAsBilling: 'Same as Billing Address',

      ShippingAddress: 'Shipping Address',

      BillingAddress: 'Billing Address',

      SameAsShipping: 'Same as shipping address',

      Email:'Email Address',

      PrimaryPhone: 'Primary Phone Number',

      AltPhone: 'Alternative Phone Number',

      General: 'General',

      Lead: 'Lead',

      Tasks: 'Tasks',

      Notes: 'Notes',

      Orders: 'Orders',

      Activity: 'Activity',

      AdditionalInformation: 'Additional Information',

      SocialMedia: 'Social Media',

      Communication: 'Communication',

      PhoneCountry: 'Country',

      PhoneType: 'Phone Type',

      NoEmail: 'No Email Address Available',

      OrderId: 'Order ID',

      OrderTime: 'Date',

      OrderStatus: 'Status',

      OrderTotal: 'Total',

      HostName: 'Host Name',

      EventDate: 'Event Date',

      ViewOrders: 'View Orders',

      Order: 'Create Order',

      ClickViewOrders: 'Click View Orders to Load Grid',

      OrderSummary: 'Order Summary',

      PersonalInformation: 'Personal Information',

      Language: 'Language',

      BirthDate: 'Birth Date',

      Misc: 'Miscellaneous',

      Group: 'Group',

      HowDidYouHear: 'How Did You Hear About Us',

      AddNotes: 'Add Note',

      SaveSuccess: 'Success!',

      SaveError: 'Error',

      ContactUpdatedSuccessfully: 'Contact has been updated successfully.',

      ContactUpdateFailed: 'Failed to update contact. Please try again.',

      AdditionalInfoUpdatedSuccessfully: 'Additional information has been updated successfully.',

      AdditionalInfoUpdateFailed: 'Failed to update additional information. Please try again.',

      SocialMediaUpdatedSuccessfully: 'Social media information has been updated successfully.',

      SocialMediaUpdateFailed: 'Failed to update social media information. Please try again.',

      RequiredFieldsMissing: 'Please fill in all required fields before saving.',

      ShippingAddressFieldsRequired: 'Please fill in all required shipping address fields.',

      BillingAddressFieldsRequired: 'Please fill in all required billing address fields.',

      PhoneRequired: 'Please enter a primary phone number.',

    },

    tabs: {

      TasksContent: 'Tasks content coming soon.',

      ActivityContent: 'Activity content coming soon.',

    },

    MyDocuments: 'My Documents',

    CommissionStatements: 'Commission Statements',

    IncentiveTracker: 'Incentive Tracker',

    IncentiveTrackerSubtitle: 'Track all active, closed, and qualified incentives.',

    IncentiveTrackerDescription: 'Check on your incentives.',

    AllIncentives: 'All Incentives',

    Active: 'Active',

    Closed: 'Closed',

    Qualified: 'Qualified',

    ViewAll: 'View All',

    ApplyFilters: 'Apply Filters',

    IncentiveType: 'Incentive Type',

    IncentiveName: 'Incentive Name',

    OnTrack: 'On Track',

    Step: 'Step',

    Countdown: 'Countdown',

    StartDate: 'Start Date',

    EndDate: 'End Date',

    Status: 'Status',

    DaysLeft: 'days left',

    Back: 'Back',

    Progress: 'Progress',

    TimeRemaining: 'Time Remaining',

    CurrentLevel: 'Current Level',

    RequirementProgress: 'Requirement Progress',

    NoIncentivesFound: 'No incentives found for the selected filter.',

    LoadingIncentives: 'Loading incentives...',

    ViewDetails: 'View Details',

    TaxDocuments: 'Tax Documents',

    SearchByDocumentTitle: 'Search by document title',

    NoCommissionDocumentsFound: 'No Commission Statements documents match your search criteria.',

    NoTaxDocumentsFound: 'No Tax documents match your search criteria.',

    DocumentUrlExpired: 'The document link has expired. Please refresh the page and try again.',

    Last3Months: 'Last 3 Months',

    Last6Months: 'Last 6 Months',

    Last12Months: 'Last 12 Months',

    Last24Months: 'Last 24 Months',

    AllTime: 'All Time',

    MyAccount: 'My Account',

    myAccountRenewalReminder: {

      message: 'Your current plan ends in {days} days. Review your renewal settings now.',

      messageToday: 'Your current plan expires today. Review your renewal settings now.',

      messageExpired: 'Your current plan has ended. Review your renewal settings now.',

      trialMessage: 'Your trial period ends in {days} days. Review your renewal settings now.',

      trialMessageToday: 'Your trial period expires today. Review your renewal settings now.',

      trialMessageExpired: 'Your trial period has ended. Review your renewal settings now.',

      action: 'Go to Webshop Settings',

      dismiss: 'Dismiss'

    },

    SelectSection: 'Select Section',

    ContactDetails: 'Contact Details',

    Address: 'Address',

    VATLiability: 'VAT Liability',

    UploadPhoto: 'Upload Photo',

    uploadPhoto: {

      UploadPhotoHeader: 'Upload Professional Photo',

      UploadPhotoSubHeader: 'Upload a professional photo to personalize your profile',

      LoadingPhoto: 'Loading photo information...',

      PageLoadError: 'Error loading photo upload page. Please try again.',

      SaveError: 'Error uploading photo',

      SaveSuccess: 'Photo uploaded successfully!',

      TryAgain: 'Try Again',

      CurrentPhoto: 'Current Profile Photo',

      ProfilePhotoAlt: 'Profile photo',

      UploadFile: 'Click to upload or drag and drop',

      MaxFileSize: 'Maximum file size: 4 MB',

      SupportedFormats: 'Supported formats: JPEG, PNG',

      SelectedFile: 'Selected File',

      RemoveFile: 'Remove File',

      PreviewAlt: 'Preview',

      FileTooLarge: 'File size exceeds 4 MB limit. Please choose a smaller file.',

      InvalidFileFormat: 'Invalid file format. Please select a JPEG or PNG image.',

      UnknownError: 'An unknown error occurred. Please try again.',

      Save: 'Save Photo',

      Uploading: 'Uploading...',

      RejectedPhotos: 'Previously Rejected Photos',

      RejectedPhotoAlt: 'Rejected photo',

      RejectionReason: 'Rejection Reason'

    },

    MyStory: 'My Story',

    myStory: {

      MyStoryHeader: 'My Story',

      MyStorySubHeader: 'Share your professional journey and expertise',

      PersonalStorySection: 'Personal Story',

      PersonalStory: 'Tell your story',

      StoryPlaceholder: 'Share your professional background, expertise, and what makes you unique as a consultant...',

      HtmlPlaceholder: 'Enter HTML code here...',

      WebsiteSection: 'Website Information',

      ConsultantWebsite: 'Consultant Website',

      LinkToConsultantWeb: 'Link to consultant web:',

      WebsitePlaceholder: 'https://your-website.com',

      InvalidURL: 'Please enter a valid URL (must start with http:// or https://)',

      SaveStory: 'Save Story',

      Saving: 'Saving...',

      LoadingStory: 'Loading your story...',

      PageLoadError: 'Error loading page',

      SaveError: 'Error saving story',

      SaveErrorGeneric: 'An error occurred while saving your story. Please try again.',

      NetworkError: 'Network error. Please check your connection and try again.',

      ValidationError: 'Please correct the errors before saving.',

      SaveSuccess: 'Your story has been saved successfully!',

      TryAgain: 'Try Again'

    },

    RecruitmentSearch: 'Recruitment Search',

    WebshopSettings: 'Webshop Settings',

    SecurityQuestions: 'Security',

    SocialMedia: 'Social Media',

    Contracts: 'Contracts',

    WalletInformation: 'Wallet Information',

    Banking: 'Banking',

    Save: 'Save',

    Cancel: 'Cancel',

    FirstName: 'First Name',

    LastName: 'Last Name',

    Email: 'Email Address',

    Phone: 'Phone Number',

    Mobile: 'Mobile Number',

    Username: 'Username',

    Facebook: 'Facebook',

    Instagram: 'Instagram',

    Pinterest: 'Pinterest',

    YouTube: 'YouTube',

    TikTok: 'TikTok',

    BillingAddress: 'Billing Address',

    DeliveryAddress: 'Delivery Address',

    MailingAddress: 'Mailing Address',

    AddNew: 'Add New',

    Change: 'Change',

    UseExisting: 'Use Existing',

    VATIDType: 'VAT/Tax ID Type',

    VATID: 'VAT ID',

    TaxID: 'Tax ID',

    UploadTaxDocument: 'Upload Tax Document',

    UploadFile: 'Upload File',

    MaxFileSize: 'Maximum file size: 4MB',

    SupportedFormats: 'Supported formats: JPEG, PNG',

    PersonalStory: 'Personal Story',

    ConsultantWebsite: 'Consultant Website',

    VisibilitySettings: 'Visibility Settings',

    ShowName: 'Show Name',

    ShowPhoto: 'Show Photo',

    ShowLocation: 'Show Location',

    LoadingVisibilitySettings: 'Loading visibility settings...',

    LoadError: 'Error loading settings',

    TryAgain: 'Try Again',

    SaveError: 'Error saving settings',

    ShowLandline: 'Show Landline',

    ShowMobile: 'Show Mobile',

    ShowEmail: 'Show Email',

    PaymentMethod: 'Payment Method',

    RenewalStatus: 'Renewal Status',

    CompanyURL: 'Company URL',

    OptOutSearch: 'Opt out of consultant search results',

    companyName: {

      CompanyName: 'Company Name',

      UpdateCompanyInfo: 'Update your company name and consultant URL',

      LoadingCompanyName: 'Loading company information...',

      PageLoadError: 'Error loading company information',

      SaveError: 'Error saving company information',

      SaveErrorGeneric: 'An unexpected error occurred while saving your company information. Please try again.',

      SaveSuccess: 'Company information saved successfully!',

      NetworkError: 'Network error occurred. Please check your connection and try again.',

      ValidationError: 'Please correct the validation errors and try again.',

      TryAgain: 'Try Again',

      SaveCompanyName: 'Save Company Name',

      Saving: 'Saving...',

      BusinessNameSection: 'Business Information',

      BusinessName: 'Business Name',

      BusinessNamePlaceholder: 'Enter your business name',

      BusinessNameHelp: 'This name will be used in your consultant URL and public profile.',

      BusinessNameRequired: 'Business name is required',

      BusinessNameTooShort: 'Business name must be at least 2 characters long',

      BusinessNameTooLong: 'Business name cannot exceed 100 characters',

      BusinessNameInvalidCharacters: 'Business name can only contain standard letters, numbers, and symbols',

      BusinessNameAlreadyExists: 'This business name is already taken. Please choose a different name.',

      ConsultantUrlSection: 'Consultant URL',

      ConsultantUrl: 'Your Consultant URL',

      UrlPlaceholder: 'your-business-name',

      UrlHelp: 'This is the web address customers will use to find your consultant page.',

      SearchVisibilitySection: 'Search Visibility',

      OptOutFromSearch: 'Become no longer shown in the consultant search results',

      OptOutHelp: 'When checked, your profile will not appear in public consultant search results.',

      UpdateOptOut: 'Update',

      Updating: 'Updating...',

      OptOutUpdateSuccess: 'Search visibility settings updated successfully!',

      OptOutUpdateError: 'Error updating search visibility',

      OptOutUpdateErrorMessage: 'An error occurred while updating your search visibility settings. Please try again.',

      UnauthorizedError: 'You are not authorized to perform this action. Please log in again.',

      TimeoutError: 'The request timed out. Please try again.'

    },

    TerminateOnlineShop: 'Terminate Online Shop',

    NewPassword: 'New Password',

    ConfirmPassword: 'Confirm Password',

    SecurityQuestion1: 'Security Question 1',

    SecurityQuestion2: 'Security Question 2',

    CustomQuestion: 'Custom Question',

    Answer: 'Answer',

    ContractName: 'Contract Name',

    Version: 'Version',

    DeliveredOn: 'Delivered On',

    SignByDate: 'Sign By Date',

    CreditCardManagement: 'Credit Card Management',

    PCICompliantPlaceholder: 'This section will integrate with Braintree for PCI-compliant payment processing.',

    BankAccountAllocation: 'Bank Account Allocation',

    OPAPaymentDetails: 'OPA Payment Details',

    BankingPlaceholder: 'Banking configuration varies by country and will include IBAN, SWIFT, routing numbers, etc.',

    SaveContactInfo: 'Save Contact Info',

    InvalidEmail: 'Please enter a valid email address',

    InvalidURL: 'Please enter a valid URL',

    PasswordComplexity: 'Password must include at least one special character',

    PasswordMismatch: 'Passwords do not match',

    RequiredField: 'This field is required',

    FileTooLarge: 'File size exceeds 4MB limit',

    InvalidFileFormat: 'Invalid file format. Please use JPEG or PNG.',

    vatLiability: {

      VATLiability: 'VAT Liability',

      VATLiabilityDescription: 'Add your VAT or Tax ID based on your tax advisor\'s guidance',

      VATInformation: 'VAT Information',

      VATIDType: 'ID Type',

      VATID: 'VAT ID',

      TaxID: 'Tax ID',

      VATIDPlaceholder: 'Enter your VAT or Tax ID',

      LoadingVatInformation: 'Loading VAT information...',

      SaveError: 'Error Saving VAT Information',

      SaveSuccess: 'VAT information saved successfully',

      TryAgain: 'Try Again',

      Save: 'Save',

      Saving: 'Saving...',

      RequiredField: 'This field is required',

      InvalidVATFormat: 'Invalid VAT format. Use DE + 9 digits or ATU + 8 digits',

      InvalidVATFormatDE: 'Invalid German VAT format. Use DE + 9 digits (e.g., DE123456789)',

      InvalidVATFormatAT: 'Invalid Austrian VAT format. Use ATU + 8 digits (e.g., ATU12345678)',

      InvalidVATFormatFR: 'Invalid French VAT format. Use FR + 2 letters/digits + 9 digits (e.g., FRXX123456789)',

      InvalidVATFormatUS: 'Invalid format. Use 5-15 alphanumeric characters',

      InvalidTaxIDFormat: 'Tax ID must be at least 5 characters',

      InvalidTaxIDFormatUS: 'Invalid US Tax ID format. Use SSN (123-45-6789) or EIN (12-3456789) or 9 digits',

      InvalidTaxIDFormatDE: 'Invalid German Tax ID format. Use 11 digits',

      InvalidTaxIDFormatFR: 'Invalid French Tax ID format. Use 9 digits (SIREN)',

      InvalidTaxIDFormatAT: 'Invalid Austrian Tax ID format. Use 9 digits',

      ValidFormat: 'Valid format detected',

      UnknownError: 'An unknown error occurred',

      NoEmailForContact: 'No email address available for contact',

      NoAddressBookEntryForContact: 'No address book entry found for this contact',

      FailedToLoadInvoices: 'Failed to load invoices',

      VATCannotBeModified: 'VAT information cannot be modified once set',

      TaxIdNoInputRequired: 'No input required for TAXID'

    },

    securityQuestions: {

      header: 'Security Questions',

      subHeader: 'Set up security questions to help recover your account',

      loading: 'Loading security questions...',

      loadError: 'Error loading security questions',

      tryAgain: 'Try Again',

      question1Label: 'Security Question 1',

      question2Label: 'Security Question 2 (Custom)',

      selectQuestion: 'Select a security question',

      selectQuestionPlaceholder: 'Choose a question...',

      customQuestionLabel: 'Create your own question',

      customQuestionPlaceholder: 'Enter your custom security question...',

      answerLabel: 'Answer',

      answerPlaceholder: 'Enter your answer...',

      save: 'Save Security Questions',

      saving: 'Saving...',

      saveSuccess: 'Security questions saved successfully!',

      saveError: 'Error saving security questions. Please try again.',

      questionRequired: 'Please select a security question',

      answerRequired: 'Please provide an answer to the security question',

      customQuestionRequired: 'Please enter a custom security question',

      customAnswerRequired: 'Please provide an answer to your custom question'

    },

    ChangesSaved: 'Changes saved successfully',

    ChangesDiscarded: 'Changes discarded',

    PersonalStoryPlaceholder: 'Tell your story and connect with customers...',

    RecruitmentSearchDescription: 'Control your visibility in consultant recruitment searches',

    SocialMediaDescription: 'Add links to your professional social media accounts',

    ContractsDescription: 'View all contracts you have signed',

    NoContracts: 'No Contracts Found',

    NoContractsDescription: 'You have not signed any contracts yet.',

    PCICompliance: 'PCI Compliance',

    AddCreditCard: 'Add Credit Card',

    EditCreditCard: 'Edit Credit Card',

    SetDefaultPayment: 'Set Default Payment Method',

    ExtendCardValidity: 'Extend Card Validity',

    DeleteCreditCard: 'Delete Credit Card',

    BraintreeIntegration: 'Braintree Integration Features',

    SecureTokenization: 'Secure card tokenization',

    PCICompliantStorage: 'PCI-compliant data storage',

    EncryptedTransmission: 'Encrypted data transmission',

    FraudProtection: 'Advanced fraud protection',

    AddNewCard: 'Add New Card',

    ManageCards: 'Manage Cards',

    DevelopmentNote: 'This feature is under development and will be available soon.',

    walletInformation: {

      WalletInformation: 'Wallet Information',

      WalletDescription: 'Manage your credit card information for secure payments',

      CardName: 'Card Name',

      CardNumber: 'Card Number',

      PayPalAccount: 'PayPal Account',

      PayPalEmail: 'PayPal Email',

      ExpirationDate: 'Expiration Date',

      NameOnCard: 'Name on Card',

      CVV: 'CVV',

      AddCard: 'Add Card',

      EditCard: 'Edit Card',

      DeleteCard: 'Delete Card',

      ExtendCard: 'Extend Card',

      SetAsDefault: 'Set as Default',

      DefaultCard: 'Default Card',

      ExpiredCard: 'Expired Card',

      ExpiresOn: 'Expires on',

      CardType: 'Card Type',

      LastFour: 'Last Four',

      NoCardsFound: 'No Cards Found',

      NoCardsDescription: 'You have not added any payment methods yet.',

      LoadingCards: 'Loading payment methods...',

      AddingCard: 'Adding card...',

      UpdatingCard: 'Updating card...',

      DeletingCard: 'Deleting card...',

      ExtendingCard: 'Extending card...',

      SettingDefault: 'Setting as default...',

      CardAdded: 'Card added successfully',

      CardUpdated: 'Card updated successfully',

      CardDeleted: 'Card deleted successfully',

      CardExtended: 'Card expiration date extended successfully',

      PayPalAdded: 'PayPal account added successfully',

      DefaultCardSet: 'Default payment method updated',

      UpdateCardError: 'Failed to update card information',

      ExtendCardError: 'Failed to extend card expiration date',

      DeleteCardError: 'Failed to delete card',

      PayPalError: 'Failed to add PayPal account',

      LoadCardsError: 'Error loading payment methods',

      CardNameRequired: 'Card name is required',

      CardNumberRequired: 'Card number is required',

      ExpirationDateRequired: 'Expiration date is required',

      NameOnCardRequired: 'Name on card is required',

      CVVRequired: 'CVV is required',

      InvalidCardNumber: 'Invalid card number',

      InvalidExpirationDate: 'Invalid expiration date',

      CardExpired: 'Card has expired',

      CardNumberFormat: 'Card number must be 13-19 digits',

      ExpirationFormat: 'Use MM/YYYY format',

      CVVFormat: 'CVV must be 3-4 digits',

      ConfirmDeleteCard: 'Are you sure you want to delete this card?',

      ConfirmDeleteCardMessage: 'This action cannot be undone.',

      Cancel: 'Cancel',

      Confirm: 'Confirm',

      Save: 'Save',

      Close: 'Close',

      Edit: 'Edit',

      Delete: 'Delete',

      Extend: 'Extend',

      UsePaymentMethod: 'Use Payment Method',

      NewExpirationDate: 'New Expiration Date',

      ExtendCardTitle: 'Extend Card Validity',

      ExtendCardDescription: 'Update the expiration date for this card',

      UpdateCardExpiration: 'Update Card Expiration',

      UpdateExpiration: 'Update Expiration',

      NoDefaultWarning: 'No default payment method selected. Please set a default card for transactions.',

      TryAgain: 'Try Again',

      SetAsPrimary: 'Assign as primary payment method',

      SetAsPrimaryDescription: 'Make this your default payment method for transactions',

      AccountName: 'Account Name',

      AccountNameRequired: 'Account name is required',

      UsageRequired: 'Usage is required',

      Name: 'Name',

      HolderName: 'Holder Name',

      Use: 'Use',

      ProcessingCard: 'Processing card information...'

    },

    BankingAllocationDescription: 'Allocate payouts across multiple bank accounts by percentage',

    MultipleAccounts: 'Multiple Bank Accounts',

    MultipleAccountsDesc: 'Add and manage multiple bank accounts for payouts',

    PercentageAllocation: 'Percentage Allocation',

    PercentageAllocationDesc: 'Distribute payouts by percentage across accounts',

    CountrySpecific: 'Country-Specific Fields',

    CountrySpecificDesc: 'Support for IBAN, SWIFT, routing numbers, etc.',

    SupportedBankingTypes: 'Supported Banking Information Types',

    IBANDescription: 'International Bank Account Number (Europe)',

    SWIFTDescription: 'Society for Worldwide Interbank Financial Telecommunication',

    RoutingNumber: 'Routing Number',

    RoutingNumberDescription: 'Bank routing number (US)',

    AccountNumber: 'Account Number',

    AccountNumberDescription: 'Bank account number',

    OPADescription: 'Manage banking details for order payments',

    BICCode: 'BIC (Bank Identifier Code)',

    BankName: 'Bank Name',

    MaskedIBAN: 'Current IBAN (Masked)',

    DirectDebitAuth: 'Direct Debit Authorization',

    DevelopmentInProgress: 'Development In Progress',

    AddBankAccount: 'Add Bank Account',

    ManageAllocation: 'Manage Allocation',

    SetupOPA: 'Setup OPA',

    banking: {

      // Page headers

      BankingDetails: 'Banking Details',

      ManagePaymentAccounts: 'Manage your payment accounts for orders and commissions',

      LoadingBankingDetails: 'Loading banking information...',

      PageLoadError: 'Unable to load banking information. Please try again.',



      // Current account section

      CurrentPaymentAccount: 'Current Payment Account',

      UpdatePaymentAccount: 'Update Payment Account',

      AddPaymentAccount: 'Add Payment Account',



      // Form fields

      BICCode: 'BIC (Bank Identifier Code)',

      BankName: 'Bank Name',

      CurrentIBAN: 'Current IBAN',

      NewIBAN: 'New IBAN',

      DirectDebitAuthorization: 'I authorize direct debit payments for orders and commissions',

      MandateReference: 'Mandate Reference',



      // Placeholders

      BICPlaceholder: 'e.g., DEUTDEFF',

      AccountHolder: 'Account Holder',

      AccountHolderPlaceholder: 'e.g., John Doe',

      BankNamePlaceholder: 'e.g., Deutsche Bank',

      BankNamePlaceholder2: 'Auto populates',

      IBANPlaceholder: 'e.g., DE89370400440532013000',



      // Validation messages

      BICRequired: 'BIC is required',

      BICInvalidLength: 'BIC must be 8-11 characters long',

      BICInvalidFormat: 'Invalid BIC format',

      InvalidBICCode: 'Invalid BIC Code',

      BankNameRequired: 'Bank name is required',

      AccountHolderRequired: 'Account holder is required',

      IBANRequired: 'IBAN is required',

      IBANInvalidLength: 'IBAN must be 15-34 characters long',

      IBANInvalidFormat: 'Invalid IBAN format',

      AuthorizationRequired: 'Direct debit authorization is required',



      // Section titles

      ManagePayouts: 'Manage your payouts',

      ConsultantPaymentAccount: 'Your consultant Payment Account (OPA)',



      // Payout grid

      PayoutAccounts: 'Payout Accounts',

      PayoutType: 'Payout Type',

      Country: 'Country',

      AccountNumber: 'Account Number',

      Deposit: 'Deposit',

      NoPayoutAccounts: 'No payout accounts configured',



      payoutType: {

        sepa: 'SEPA',

        bankTransfer: 'Bank Transfer',

      },



      // Modal

      AddAccount: 'Add Account',

      AddNewAccount: 'Add New Account',

      AccountType: 'Account Type',

      DirectDeposit: 'Direct Deposit (Savings)',

      Check: 'Check',

      DepositPercentage: 'Deposit Percentage',

      DepositPercentagePlaceholder: 'e.g., 50',

      DepositPercentageInvalid: 'Deposit percentage must be between 1 and 100',

      IBAN: 'IBAN',

      Save: 'Save',

      Cancel: 'Cancel',



      // Actions

      SaveNewAccount: 'Save New Account',

      RemoveAccount: 'Remove Payment Account',

      UpdatePayoutDistribution: 'Update Payout Distribution',

      Saving: 'Saving',

      Removing: 'Removing',

      TryAgain: 'Try Again',



      // Validation

      PercentageTotalMustBe100: 'Total percentage must equal 100%. Current total: {total}%',

      InvalidPayoutPercentage: 'Please adjust the payout percentage. The total percentage between all currently active and future payouts must be 100% per period.',



      // Success/Error messages

      SaveSuccess: 'Banking information saved successfully',

      SaveError: 'Failed to save banking information',

      UnknownError: 'An unknown error occurred',

      RemoveNotImplemented: 'Remove functionality is not yet implemented',

      UpdateDistributionNotImplemented: 'Update distribution functionality is not yet implemented',



      // Delete confirmation

      DeleteAccount: 'Delete Account',

      DeleteAccountConfirmation: 'Are you sure you want to delete this payout account?',

      DeleteAccountWarning: 'This action cannot be undone.',

      Delete: 'Delete',

      DeleteSuccess: 'Payout account deleted successfully',

      DeleteError: 'Failed to delete payout account'

    },

    EnterCustomQuestion: 'Enter your custom security question',

    SecurityQuestionsAPIPlaceholder: 'The Security Questions API is currently under development. This feature will be available soon with dynamic question loading and secure answer storage.',

    FeatureInDevelopment: 'Feature In Development',

    LoadingContracts: 'Loading contracts...',

    Saving: 'Saving...',

    Question: 'Question',

    ChangePassword: 'Change Password',

    Abort: 'Abort',

    NoAddressSet: 'No address set',

    EditAddress: 'Edit Address',

    AddNewAddress: 'Add New Address',

    Address1: 'Address Line 1',

    Address2: 'Address Line 2',

    City: 'City',

    State: 'State/Province',

    PostalCode: 'Postal Code',

    Country: 'Country',

    SelectedFile: 'Selected File',

    Uploading: 'Uploading...',

    ReportDashboard: 'Team',

    CongratulationsMessage: 'Congrats! You are getting paid at {title} this month.',

    ClassId: 'Class',

    ThisMonth: 'This Month',

    ThisYear: 'This Year',

    PersonalTeamSales: 'Personal Team Sales',

    OrganizationSales: 'Organization Sales',

    TeamRecruits: 'Team Recruits',

    TeamEndCount: 'Team End Count',

    GettingStarted: 'Getting Started',

    AtRisk: 'At Risk',

    RoadToSuccess: 'Road To Success',

    NewConsultants: 'New Consultants',

    SeniorConsultantsAndTeamLeaders: 'Senior Consultants and Team Leaders',

    NotPaidAtTitle: 'Not Paid at Title',

    Inactive: 'Inactive',

    CloseToLosingCareerSales: 'Close to Losing Career Sales',

    LessThan3PartiesBooked: 'Less than 3 Parties Booked Next Month',

    CloseToPromoting: 'Close to Promoting',

    CloseToEarningTravelIncentive: 'Close to Earning a Travel Incentive',

    CloseToEarningSalesPromo: 'Close to Earning Sales Promo',

    Leaderboard: 'Leaderboard',

    Recruits: 'Recruits',

    QualifiedRecruits: 'Qualified Recruits',

    CommissionableSales: 'Commissionable Sales',

    GenerateRecognitionImage: 'Generate Recognition Image',

    RecognitionCongratulations: 'CONGRATULATIONS!',

    RecognitionFirstPlace: 'First Place on My Team!',

    RecognitionOutstanding: 'Outstanding performance in {metric}!',

    MyPersonalTeam: 'My Personal Team',

    AllLevels: 'All Levels',

    AllStatus: 'All Status',

    Name: 'Name',

    Title: 'Title',

    PersonalSales: 'Personal Sales',

    ActiveConsultants: 'Active Consultants',

    address: {

      // Page headers

      AddressManagement: 'Address Management',

      ManageAddresses: 'Manage your billing, shipping, and mailing addresses',

      LoadingAddresses: 'Loading address information...',

      PageLoadError: 'Unable to load address information. Please try again.',



      // Address types

      BillingAddress: 'Billing Address',

      DeliveryAddress: 'Shipping Address',

      MailingAddress: 'Mailing Address',



      // Actions

      AddNew: 'Add New',

      Change: 'Change',

      UseExisting: 'Use Existing',

      Save: 'Save',

      Saving: 'Saving...',

      Cancel: 'Cancel',

      TryAgain: 'Try Again',



      // Form labels

      ContactInfo: 'Contact Information',

      AddressDetails: 'Address Details',

      FirstName: 'First Name',

      LastName: 'Last Name',

      AddressLine1: 'Address Line 1',

      AddressLine2: 'Address Line 2 (Optional)',

      City: 'City',

      StateCode: 'State/Province',

      PostalCode: 'Postal Code',

      CountryCode: 'Country',



      // Form titles

      AddNewAddress: 'Add New Address',

      EditAddress: 'Edit Address',

      SelectExistingAddress: 'Select Existing Address',



      // Status messages

      NoAddressSet: 'No address set',

      NoSavedAddresses: 'No saved addresses available',



      // Validation messages

      FirstNameRequired: 'First name is required',

      LastNameRequired: 'Last name is required',

      AddressLine1Required: 'Address line 1 is required',

      CityRequired: 'City is required',

      StateCodeRequired: 'State/Province is required',

      PostalCodeRequired: 'Postal code is required',

      CountryCodeRequired: 'Country is required',

      ValidationError: 'Please correct the validation errors and try again',



      // Success/Error messages

      SaveSuccess: 'Address information saved successfully!',

      SaveError: 'Failed to save address information',

      SaveErrorGeneric: 'An error occurred while saving. Please try again.',

      NetworkError: 'Network error. Please check your connection and try again.'

    },

    contracts: {

      title: 'Contracts',

      description: 'View a list of contracts you have signed',

      name: 'Name',

      version: 'Version',

      deliveredOn: 'Delivered On',

      signByDate: 'Sign By Date',

      loading: 'Loading contracts...',

      noContracts: 'No Contracts Found',

      noContractsDescription: 'You have not signed any contracts yet.'

    }

  },

  webshopSettings: {

      // Page headers

      WebshopSettings: 'Webshop Settings',

      ManageWebshopSettings: 'Enable consultants to manage webshop settings, payment methods, and renewals',

      LoadingWebshopSettings: 'Loading webshop settings...',

      PageLoadError: 'Unable to load webshop settings. Please try again.',



      // Plan Selection

      chooseYourPlan: 'Choose Your Plan',

      manageYourPlan: 'Manage Your Plan',

      activeSubscription: 'Active Subscription',

      start90DaysTrial: 'Start your 90-day free trial today',

      startFreeTrial: 'Start Free Trial',

      trialPeriod: 'Trial Period',

      noPlanSelected: 'No Plan Selected',

      noPlanSelectedMessage: 'Click on a plan below to select it for when your trial ends.',

      noPlanSelectedAssuranceMessage: 'You will not be charged or automatically enrolled unless you select a plan.',

      trialActiveMessage: 'You are currently active in the trial program.',

      trialPlanSelectionNearEndMessage: 'You will be able to choose your plan starting 10 days before your trial ends ({countdown}). You will not be charged or automatically enrolled unless you select a plan.',

      countdownInOneWeek: 'in 1 week',

      countdownInWeeks: 'in {count} weeks',

      countdownInOneDay: 'in 1 day',

      countdownInDays: 'in {count} days',

      currentSelection: 'Current Selection',

      plan: 'Plan',

      trialSelectionMessage: 'You can change your plan or opt out anytime before your trial ends. Your card will not be charged if no plan is selected.',

      trialEndsOn: 'Your trial period ends on',

      continueToPurchase: 'Continue to Purchase',

      currentPaymentMethod: 'Current Payment Method',

      manageBilling: 'Manage Billing',

      selectPaymentMethod: 'Select Payment Method',

      addNewCard: 'Add New Card',

      processingCard: 'Processing card...',

      cancel: 'Cancel',

      select: 'Select',

      current: 'Current',

      pending: 'Pending',

      monthly: 'Monthly',

      quarterly: 'Quarterly',

      biAnnual: 'Bi-Annual',

      annual: 'Annual',

      savePercent: 'Save {savings}%',

      visa: 'VISA',

      expires: 'Expires',

      processing: 'Processing...',

      selectAPlan: 'Select a plan',

      confirmPlanSelection: 'Confirm Plan Selection',

      confirmPlanMessage: 'Are you sure you want to select this plan? This will be your renewal plan when your trial ends.',

      confirm: 'Confirm',

      pendingChange: 'Pending Change',

      pendingChangeMessage: 'You can change your plan at any time. Changes will take effect on {renewalDate}.',

      currentPlan: 'Current Plan',

      month: 'month',

      sixMonths: '6 months',

      year: 'year',

      frequency: {

        perMonth: 'per month',

        everyThreeMonths: 'every 3 months',

        everySixMonths: 'every 6 months',

        perYear: 'per year',

      },

      planChangeMessage: 'You can change your plan at any time. Changes will take effect on your next billing cycle.',

      upgradeMessage: 'You can upgrade to a different plan at any time. Changes will take effect on your next billing cycle.',

      subscriptionActive: 'Your subscription is active',

      subscriptionEndsOn: 'Your subscription will end on: {renewalDate}',

      nextBilling: 'Next billing',

      cancelPendingChange: 'Cancel Pending Change',

      cancelPendingChangeTitle: 'Cancel Pending Change',

      cancelPendingChangeMessage: 'Are you sure you want to cancel your pending plan change? Your current plan will remain active.',

      confirmCancel: 'Confirm Cancellation',

      cancelSubscription: 'Cancel Subscription',

      cancelSubscriptionTitle: 'Cancel Subscription',

      cancelSubscriptionMessage: 'Your subscription will not renew after the renewal date. Are you sure you want to cancel?',

      confirmCancelSubscription: 'Confirm Cancellation',

      subscriptionCancelledMessage: 'You have cancelled your subscription. Your subscription will not renew after the renewal date. You can re-enroll after your current subscription expires.',

      deleteCardTitle: 'Delete Card',

      deleteCardMessage: 'Are you sure you want to delete this card? This action cannot be undone.',

      confirmDeleteCard: 'Delete Card',



      // Expired/No Active Subscription State

      noActiveSubscription: 'No Active Subscription',

      noCurrentSubscription: 'No Current Subscription',

      noCurrentSubscriptionMessage: 'Select a plan below to get started. You can change or cancel anytime.',

      invalidPaymentMethod: 'Invalid Payment Method',

      invalidPaymentMethodMessage: 'Add or change your payment method.',

      paymentDue: 'Payment Due',

      renewalProcessingTitle: 'Renewal Processing',

      renewalProcessingMessage: 'Your renewal change is currently being processed. Please wait while this update is completed.',

      renewalProcessingPendingLabel: 'Your renewal is being processed. Plan and billing actions are temporarily unavailable.',

      getStartedToday: 'Get started today',

      choosePlanToBegin: 'Choose a plan to begin your subscription',

      paymentSetupRequired: 'Payment Setup Required',

      paymentSetupMessage: 'You\'ll be prompted to add a payment method after selecting your plan. No charges until you confirm.',

      reenroll: 'Re-enroll',



      // Actions

      ChangePlan: 'Change Plan',

      Enroll: 'Enroll',

      RenewEnrollment: 'Renew Enrollment',

      Reenroll: 'Reenroll',

      TerminateOnlineShop: 'Terminate Online Shop',

      Unenroll: 'Unenroll',

      UpdatePendingChanges: 'Update Pending Changes',

      RevertPendingChanges: 'Revert Pending Changes',

      TryAgain: 'Try Again',



      // Current Plan Section

      CurrentPlan: 'Current Plan Information',

      PlanName: 'Plan Name',

      RenewalFrequency: 'Renewal Frequency',

      ProcessStatus: 'Process Status',

      NextRenewalDate: 'Next Renewal Date',



      // Current Configuration Section

      CurrentConfiguration: 'Current Configuration',

      CurrentProgramName: 'Current Program Name',

      CurrentOptionalPrograms: 'Current Optional Programs',

      RenewalDate: 'Renewal Date',

      ExpiresOn: 'Expires On',



      // Current Program Section (legacy)

      CurrentProgram: 'Current Program Information',

      RequiredProgram: 'Required Program',

      OptionalPrograms: 'Optional Programs',

      NoOptionalPrograms: 'No optional programs',



      // Pending Changes Section

      PendingChanges: 'Pending Changes',

      Current: 'Current Configuration',

      Pending: 'Pending Configuration',

      PendingConfiguration: 'Pending Configuration',

      Program: 'Program',

      PeriodName: 'Period Name',

      FuturePeriodName: 'Future Period Name',

      FutureProgramName: 'Future Program Name',

      FutureOptionalPrograms: 'Future Optional Programs',

      EffectiveDate: 'Effective Date',



      // Next Payment Section

      NextPayment: 'Next Payment',

      RenewalOverdue: 'Renewal Overdue',

      AccountOverdueMessage: 'Your account renewal is overdue. Please update your payment information.',

      CardWillBeCharged: 'Your card will be charged',



      // Payment Information Section (legacy)

      PaymentInformation: 'Payment Information',

      NextChargeAmount: 'Next Charge Amount',

      NextChargeDate: 'Next Charge Date',



      // Secondary Plan Section

      SecondaryPlan: 'Secondary Plan Information',

      SecondaryPlanName: 'Secondary Plan Name',

      SecondaryStatus: 'Secondary Status',

      SecondaryRenewalDate: 'Secondary Renewal Date',

      SecondaryRenewalConfigurationPending: 'Renewal configuration status is pending',



      // Configuration Status Messages

      RenewalConfigurationPending: 'Renewal Configuration Pending',

      RenewalConfigurationPendingMessage: 'Your renewal configuration is currently being processed. Please check back later.',

      NoActivePlan: 'No Active Plan',

      NoActivePlanMessage: 'You are not currently enrolled in any plan. Click "Reenroll" to join a renewal program.',



      // Status values

      StatusActive: 'Active',

      StatusPending: 'Pending',

      StatusExpired: 'Expired',

      StatusCancelled: 'Cancelled',

      StatusProcessing: 'Processing',



      // Success/Error messages

      SaveSuccess: 'Webshop settings updated successfully!',

      SaveError: 'Failed to update webshop settings',

      SaveErrorGeneric: 'An error occurred while updating. Please try again.',

      NetworkError: 'Network error. Please check your connection and try again.',



      // Change Plan Modal

      ChangePlanModalTitle: 'Change Plan',

      ChangePlanModalDescription: 'Select a new renewal frequency and programs for your plan',

      SelectRenewalFrequency: 'Select Renewal Frequency',

      RenewalFrequencyPlaceholder: 'Choose renewal frequency...',

      LoadingRenewalFrequencies: 'Loading renewal frequencies...',

      NoRenewalFrequenciesAvailable: 'No renewal frequencies available',

      RequiredPrograms: 'Required Programs',

      OptionalProgramsSelection: 'Optional Programs',

      LoadingPrograms: 'Loading programs...',

      NoProgramsAvailable: 'No programs available',

      Kits: 'Kits',

      LoadingKits: 'Loading kits...',

      NoKitsAvailable: 'No kits available for selected programs',

      SelectProgram: 'Please select a program to view available kits',

      Cancel: 'Cancel',

      SaveChanges: 'Save Changes',

      ChangePlanSuccess: 'Plan changed successfully!',

      ChangePlanError: 'Failed to change plan',



      // Revert Confirmation Modal

      ConfirmRevert: 'Confirm Revert Changes',

      ConfirmRevertMessage: 'Are you sure you want to revert the pending changes? This action cannot be undone.',

      ConfirmRevertButton: 'Yes, Revert Changes',



      // Select Payment Method Modal

      SelectPaymentMethod: 'Select Payment Method',

      SelectPaymentDescription: 'Choose the payment method you want to use for renewal payments',

      LoadingPaymentMethods: 'Loading payment methods...',

      NoPaymentMethodsAvailable: 'No payment methods available. Please add a payment method first.',

      CurrentRenewalCard: 'Current Renewal',

      CardNumber: 'Card Number',

      ExpirationDate: 'Expiration Date',

      HolderName: 'Holder Name',

      ConfirmSelection: 'Confirm Selection',



      // Renewal Countdown Notification

      RenewalReminder: 'Renewal Reminder',

      RenewalReminderMessage: 'Your renewal is coming up in {days} days!'

    },

  account: {

    ChooseOption: 'Choose Your Option',

    ChooseDescription: 'Do you already have an account with us?',

    HaveAccount: 'Yes, I have an account',

    CreateAtCheckout: 'No, I will create one at checkout'

  },

  kit: {

    miniHeader: 'Here\'s everything you need to get started.',

    kitHeader: 'Choose a Kit Packed with Our Bestselling Tools',

    startForFree: 'Would you like to start for free without a starter set? Please contact',

    contactLabel: 'Contact:',

    details: 'Details',

    productsInKit: 'Products in This Kit:',

    startUpBox: 'Start-Up Box:',

    totalValue: '({0} total value!)',

    selectKitTitle: 'Select Your Kit',

    selectKitMessage: 'Multiple kits are available for your country. Please select the kit you would like to purchase:',

    selectKit: 'Select This Kit',

    noProductsAvailable: 'No kit products are available for the selected country. Please contact customer service for assistance.'

  },

  gamificationDifferenceMessage: {

    OrderTotal_FreeShipping: 'Free Shipping when you spend over {totalAmount}',

    PartyOrderTotal_FreeShipping: 'Free Shipping when you spend over {totalAmount}',

    OrderTotal: 'Spend only {difference} more to get additional discounts',

  },

  richTextEditor: {

    Design: 'Design',

    HTML: 'HTML',

    Preview: 'Preview',

    designMode: 'Design',

    htmlMode: 'HTML',

    previewMode: 'Preview',

    normalText: 'Normal Text',

    heading1: 'Heading 1',

    heading2: 'Heading 2',

    heading3: 'Heading 3',

    paragraph: 'Paragraph',

    bold: 'Bold',

    italic: 'Italic',

    underline: 'Underline',

    strikeThrough: 'Strikethrough',

    alignLeft: 'Align Left',

    alignCenter: 'Align Center',

    alignRight: 'Align Right',

    justify: 'Justify',

    bulletList: 'Bullet List',

    numberedList: 'Numbered List',

    decreaseIndent: 'Decrease Indent',

    increaseIndent: 'Increase Indent',

    textColor: 'Text Color',

    backgroundColor: 'Background Color',

    createLink: 'Create Link',

    removeLink: 'Remove Link',

    enterUrl: 'Enter URL:',

    htmlPlaceholder: 'Enter HTML code here...'

  },

  FrenchContribution: 'French Tax Documents',

  frenchContribution: {

    FrenchContributionHeader: 'French Tax Documents',

    FrenchContributionSubHeader: 'Upload your tax-related documents for compliance review and approval',

    SiretNumber: 'SIRET Number',

    UploadFile: 'Click to upload or drag and drop your tax document',

    MaxFileSize: 'Maximum file size: 10MB',

    SupportedFormats: 'Supported format: PDF only',

    SelectedFile: 'Selected File',

    RemoveFile: 'Remove File',

    Upload: 'Upload Document',

    Uploading: 'Uploading...',

    LoadingDocuments: 'Loading documents...',

    PageLoadError: 'Error loading French contribution section',

    SaveError: 'Upload Failed',

    SaveSuccess: 'Document uploaded successfully! Your tax document has been submitted for review.',

    TryAgain: 'Try Again',

    FileTooLarge: 'File size exceeds 10MB limit. Please choose a smaller file.',

    InvalidFileFormat: 'Only PDF files are supported. Please select a PDF document.',

    UnknownError: 'An unexpected error occurred. Please try again.'

  },

  eventTasks: {

    title: 'Event Tasks',

    subtitle: 'Accepted Leads',

    loading: 'Loading leads...',

    noLeads: 'No accepted leads found.',

    email: 'Email',

    phone: 'Phone',

    leadType: 'Lead Type',

    source: 'Source',

    note: 'Note',

    loadingNote: 'Loading note...',

    notePlaceholder: 'Add a note about this lead...',

    saveNote: 'Save Note',

    created: 'Created',

    assigned: 'Assigned',

    accepted: 'Accepted',

    partyDate: 'Party Date',

    theme: 'Theme',

    bestTime: 'Best Time to Contact',

    tasks: 'Tasks',

    due: 'Due',

    registerNewMember: 'Register a New Member',

    joinMyTeam: 'Join My Team',

    saveTasks: 'Save Tasks',

    joinMyTeamUrlCopied: 'Join My Team URL copied to clipboard!',

    failedToCopyUrl: 'Failed to copy URL. Please try again.',

    failedToLoadLeads: 'Failed to load leads. Please try again.',

    failedToSaveTasks: 'Failed to save tasks. Please try again.',

    failedToSaveNote: 'Failed to save note. Please try again.',

    tasksSavedSuccessfullyFor: 'Tasks saved successfully for {firstName} {lastName}',

    noteSavedSuccessfullyFor: 'Note saved successfully for {firstName} {lastName}',

    errorLoadingNote: 'Failed to load note. Please try again.',

    coaching: {

      contact: 'Talk about the great opportunity benefits and share with them your personal story of how TPC has enriched your life.',

      email: 'Paste the following link into an email and send it to your recruit\n{fullUrl}\nBe sure to let them know to put in your consultant ID when prompted through the sign up process',

      followup: 'Phone the Prospect to ensure that she receives the contract and answer any questions she may have.',

    },

    taskNames: {

      contact: 'Contact Potential Consultant',

      email: 'Email Potential Consultant the Link to Enroll',

      followup: 'Follow Up Phone Call with Potential Consultant',

    },

  },

  businessDetails: {

    Title: 'Business Details',

    ShowChart: 'Show Chart',

    ShowGrid: 'Show Grid',

    Metrics: 'Metrics',

    ChartTitle: 'Business Metrics Over Time',

    errors: {

      noColumnsFoundInReportDefinition: 'No columns found in report definition',

      noBatchHistoryFound: 'No batch history found',

      failedToLoadData: 'Failed to load data',

    },

  },

  teamIncentiveDetails: {

    Title: 'Team Incentive Details',

    NoReportsFound: 'No incentive reports found',

    SelectIncentive: 'Incentive',

    SelectPlaceholder: 'Select an incentive report...'

  },

  consultantActivity: {

    Title: 'Consultant Activity',

    SelectBatch: 'Select Batch Period',

    SelectBatchPlaceholder: 'Select a batch...',

    SelectedBatchInfo: 'Selected Batch Information',

    BatchName: 'Batch Name',

    BatchNumber: 'Batch Number',

    HistoryDate: 'History Date',

    NoDataAvailable: 'No data available for the selected batch',

    AdjustmentsTab: 'Adjustments',

    ActivityTab: 'Activity',

    OrdersTab: 'Orders',

    ActivityTabPlaceholder: 'Activity report will be displayed here. Implementation coming soon.',

    OrdersTabPlaceholder: 'Orders report will be displayed here. Implementation coming soon.',

    Metric: 'Metric',

    Value: 'Value',

    IncludeTeam: 'Include Team',

    RemoveTeam: 'Remove Team'

  },

  ccReport: {

    Filters: 'Filters',

    ApplyFiltersToTableData: 'Apply filters to table data',

    NoFilterableColumns: 'No filterable columns available for this report.',

    StartDate: 'Start Date',

    EndDate: 'End Date',

    ClearFilters: 'Clear Filters',

    ApplyFilters: 'Apply Filters',

    IncludeTeam: 'Include Team',

    RemoveTeam: 'Remove Team',

    ItemsPerPage: 'items per page',

    ShowingItems: '{0} - {1} of {2} items',

    NoRecordsAvailable: 'No records available'

  },

  ccConsultantDetail: {

    ConsultantDetails: 'Consultant Details',

    LoadingDetails: 'Loading consultant details...',

    FullName: 'Full Name',

    Status: 'Status',

    Address: 'Address',

    Phone: 'Phone',

    Email: 'Email',

    Sponsor: 'Sponsor',

    Recruiter: 'Recruiter',

    PersonalGroup: 'Personal Group',

    NotAvailable: 'Not available',

    ProfilePhotoAlt: 'Consultant profile photo',

    AddBookmark: 'Add bookmark',

    RemoveBookmark: 'Remove bookmark',

    Retry: 'Retry',

    BusinessDetails: 'Business Details',

    ViewBusinessDetails: 'View Business Details',

    SearchConsultant: 'Search Consultant',

    SearchPlaceholder: 'Type to search consultants...',

    NoAddressAvailable: 'No address available',

    Bookmark: 'Bookmark',

    BookmarkedConsultants: 'Bookmarked Consultants',

    NoBookmarkedConsultants: 'No bookmarked consultants yet'

  },

  phoneInput: {

    placeholder: 'Enter phone number',

    phoneNumber: 'Phone number',

    extension: 'Ext.',

    type: 'Phone Type',

    home: 'Home',

    cell: 'Cell',

    work: 'Work',

    other: 'Other',

    required: 'Phone number is required',

    invalid: 'Please enter a valid phone number',

    country: {

      DE: 'DE',

      AT: 'AT',

      FR: 'FR',

    }

  },

  marketing: {

    optInConfirm: {

      title: 'Email Confirmation',

      confirmedMessage: 'Thank you for confirming your email subscription.',

      noEmailProvided: 'No email address provided.',

    },

  },

  hostPortalPage: {

    loadingEventDetails: 'Loading event details...',

    genericErrorTitle: 'Oops! Something went wrong',

    tryAgain: 'Try Again',

    eventTitleFallback: "{name}'s Event",

    eventSubtitle: 'Pampered Chef Event',

    eventImageAlt: 'Event image {number}',

    descriptionTitle: 'Pamper Your Kitchen This Summer!',

    hostedBy: 'Hosted By',

    location: 'Location',

    eventDescription: 'Welcome to my Pampered Chef event! Join us for a fun time with great products.',

    shopNow: 'Shop Now',

    shareThisInvite: 'Share this invite',

    shareText: 'Text',

    shareFacebook: 'Facebook',

    shareEmail: 'Email',

    copy: 'Copy',

    starts: 'Starts',

    hostingQuestion: 'Are you hosting the party?',

    signInToSeeDashboard: 'Sign in to see your dashboard',

    inviteLinkCopiedTitle: 'Copied',

    inviteLinkCopiedMessage: 'Invite link copied to clipboard',

    unknownHost: 'Unknown Host',

    errors: {

      noEventIdProvided: 'No event ID provided',

      eventNotFound: 'Event not found',

      loadingEventDetails: 'Error loading event details',

      copyInviteLinkFailed: 'Failed to copy invite link',

      guestNotFound: 'Guest not found for this event',

      loadingGuestDetails: 'Error loading guest details',

      updateStatusFailed: 'Could not update your RSVP. Please try again.',

    },

    guestSection: {

      heading: 'Your RSVP',

      greeting: 'Hi {name},',

      currentStatusLabel: 'Your current status:',

      changeStatusLabel: 'Update your RSVP:',

      statusUpdatedTitle: 'RSVP updated',

      statusUpdatedMessage: 'Thanks! Your RSVP has been saved.',

    },

  }

  ,

  kendo: {

    grid: {

      pagerItemsPerPage: 'items per page',

      pagerInfo: '{0} - {1} of {2} items',

      noRecords: 'No records available',
      noRecordsFound: 'No records found',
      noOrdersAvailable: 'No orders available',
      noPartiesAvailable: 'No parties available',
    },
    upload: {
      select: 'Select files...',
      dropFilesHere: 'Drop files here to upload',
      remove: 'Remove',
      invalidFileExtension: 'File type not allowed.',
      invalidMaxFileSize: 'File size too large.',
    },

  },

  countries: {

    germany: 'Germany',

    austria: 'Austria',

    france: 'France',

    switzerland: 'Switzerland',

    belgium: 'Belgium',

    spain: 'Spain',

    italy: 'Italy',

    netherlands: 'Netherlands',

    poland: 'Poland',

    unitedKingdom: 'United Kingdom',

    ireland: 'Ireland',

    portugal: 'Portugal',

    sweden: 'Sweden',

    denmark: 'Denmark',

    norway: 'Norway',

    finland: 'Finland',

    unitedStates: 'United States',

    canada: 'Canada',

    australia: 'Australia',

    newZealand: 'New Zealand',

    japan: 'Japan',

    china: 'China',

    brazil: 'Brazil',

    mexico: 'Mexico',

    india: 'India',

    unknown: 'Unknown',

  },

  pagination: {

    previousPage: 'Previous page',

    nextPage: 'Next page',

    goToPage: 'Go to page {page}',

    ellipsis: '...',

  },

  myStory: {

    NoStoryAvailable: 'No story available at this time.',

  }

}

